import { vpsReducer } from "app/vpsReducer";
import NoPeek from "assets/images/icons/nopeek.svg";
import Peek from "assets/images/icons/peek.svg";
import AddToCartButton from "components/AddToCartButton";
import AddonsVPSDropdown from "components/AddonsVPSDropdown";
import BillingCycleOptions from "components/BillingCycleOptions";
import CardWrapper from "components/CardWrapper";
import ServerOptions from "components/ServerOptions";
import PromoKaosTumbler from "components/PromoKaosTumbler";
import {
  addToCart,
  changeProductFromCart,
  addVpsAddons,
  addPromo,
  removeVpsAddons,
  setQueryPromo,
  removePromoCode,
} from "features/common/layouts/cartSlice";
import {
  getProduct,
  selectProduct,
} from "features/common/products/productsSlice";
import { formatIDR, useQuery } from "helpers/utils";
import {
  getAddonsVPS,
  getProductsPromoVPS,
  getVpsByServer,
} from "features/vps/vpsSlice";
import { buildProdName, checkPasswordStrength } from "helpers/helper";
import { useCallback, useEffect, useReducer, useRef, useState } from "react";
import { Placeholder, ProgressBar } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import collapseIcon from "../../assets/images/icons/vcollapse.png";
import MainLayouts from "../../layouts/MainLayouts";
// import styles from "../../assets/scss/Vps.module.scss"; // File sudah dihapus
import { useLocation } from "react-router-dom";
import Form from "react-bootstrap/Form";
import { notifyError, notifyWarning, notifySuccess } from "components/ToastMessage";
import { setOrderParams } from "features/common/layouts/cartSlice";
import VpsOsAppSelector from "components/VpsOsAppSelector";
import VpsSpecsDisplay from "components/VpsSpecsDisplay";
import ConfigSizeSelector from "components/ConfigSizeSelector";

const vpsProductInit = [
  { id: 1, value: "Nano SC" },
  { id: 2, value: "SC1" },
  { id: 3, value: "SC2" },
  { id: 4, value: "SC4" },
  { id: 5, value: "SC8" },
  { id: 6, value: "SC16" },
  { id: 7, value: "SC32" },
  { id: 8, value: "SC64" },
];


const bundlePromos = [
  {
    id: 1,
    label: "Bundle ISPManager Lite + Immunify AV",
    value: "ISPManager Lite + ImmunifyAV",
  },
  // {
  //   id: 1,
  //   label: "Bundle cPanel Solo + Cloudlinux Solo + Immunify Single User",
  //   value: "cPanel + Cloudlinux + Immunify",
  // },
  {
    id: 2,
    label:
      "Bundle Plesk for VPS Web Admin Edition + Cloudlinux Solo + Immunify Single User",
    value: "Plesk + Cloudlinux + Immunify",
  },
  {
    id: 3,
    label:
      "Bundle DirectAdmin Personal Plus (Max 2 Account 20 Addon) + Cloudlinux Solo + Immunify Single User",
    value: "DirectAdmin + Cloudlinux + Immunify",
  },
];

const Vps = () => {
  const query = useQuery();
  const location = useLocation();
  const dispatch = useDispatch();
  const firstLoad = useRef(true);
  const snapshotRef = useRef(false);
  const hostnameRef = useRef(null);
  const passwordRef = useRef(null);
  const peekIconRef = useRef(null);
  const addonsRef = useRef(null);
  const debounceTimerRef = useRef(null);
  const isUpdatingPidRef = useRef(false); // Flag untuk mencegah konflik PID update
  const isManualServerChangeRef = useRef(false); // Flag untuk mencegah konflik saat perubahan server manual
  const isInitializingRef = useRef(true); // Flag untuk inisialisasi pertama kali
  const isVpsTypeChangingRef = useRef(false); // Flag untuk mencegah konflik saat perubahan tipe VPS
  const lastChangeTimeRef = useRef(0); // Timestamp untuk mencegah perubahan terlalu cepat

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pid = params.get("pid");
    const billingcycle = params.get("billingcycle");
    dispatch(setOrderParams({ pid, billingcycle }));
  }, [location.search, dispatch]);

  const currentProduct = useSelector(selectProduct);
  const { products: vpsProductsGroup, addonsVPS } = useSelector(
    (state) => state.vps
  );
  const { productsList } = useSelector((state) => state.cart);
  
  const { activeGID, current: activeProd } = currentProduct;
  // console.log(activeGID, 'activeGID');
  const { pid: pidOnCart } = currentProduct.current;
  
  // Deteksi Managed VPS (gid 734 dengan pid 1167-1170)
  const isManagedVPS = activeGID === 734 && [1167, 1168, 1169, 1170].includes(activeProd?.pid);
  
  const [server, setServer] = useState(0);
  const [priceByTermin, setPriceByTermin] = useState(0);
  const [prodsValue, setProdsValue] = useState("Nano SC"); // Default ke Nano SC
  // Tambahkan state untuk tipe VPS (Paket vs Custom) - harus didefinisikan sebelum currentProdName
  const [vpsType, setVpsType] = useState("paket");

  const [bundleValue, setBundleValue] = useState({
    forLabel: "",
    forValue: "empty",
  });
  const [passwordStrength, setPasswordStrength] = useState({
    title: null,
    variant: "danger",
    score: 0,
  });
  const [termin, setTermin] = useState("annually");
  const [vpsPid, setVpsPid] = useState(null);
  const [changeProduct, setChangeProduct] = useState(true);
  const [noBundle, setNoBundle] = useState(false);
  const [isSoftaculous, setIsSoftaculous] = useState(false);
  const [hargaBundle, setHargaBundle] = useState(0);
  const [currentBundlingPanel, setCurrentBundlingPanel] = useState(0);
  const [delBundlePrice, setDelBundlePrice] = useState(0);
  const [bundlePrice, setBundlePrice] = useState(0);
  const [currentPanel, setCurrentPanel] = useState(false);
  const [currentSupport, setCurrentSupport] = useState(false);
  const [currentSoftaculous, setCurrentSoftaculous] = useState(false);
  const [currentBackup, setCurrentBackup] = useState(false);
  const [currentOthers, setCurrentOthers] = useState(false);
  const [currentName, setCurrentName] = useState(null);
  const [showPromoBundling, setShowPromoBundling] = useState(false);
  const [bundlePromo, setBundlePromo] = useState("choose");
  const [showPromo, setShowPromo] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [selectedType, setSelectedType] = useState("os");
  const [selectedOsOrApp, setSelectedOsOrApp] = useState("choose");
  const [selectedVersion, setSelectedVersion] = useState("");
  const [selectedOsName, setSelectedOsName] = useState({ os_name: "", osid: null, osAddon: null });
  const [customfields, setCustomfields] = useState([]);
  const [productListCache, setProductListCache] = useState(null);
  const [hostnameError, setHostnameError] = useState("");
  // State untuk Managed VPS panel selection (default: DirectAdmin Personal Plus ID 157)
  const [selectedManagedPanel, setSelectedManagedPanel] = useState(null); // Akan di-set ke ID 157 saat addons tersedia
  // State untuk Managed VPS Immunify selection (default: Immunify 360 Single Hosting Account ID 117)
  const [selectedManagedImmunify, setSelectedManagedImmunify] = useState(null); // Akan di-set ke ID 117 saat addons tersedia
  // State untuk daftar produk Managed VPS dari gid 734
  const [managedVpsProducts, setManagedVpsProducts] = useState([]);
  // State untuk produk Managed VPS yang dipilih
  const [selectedManagedProduct, setSelectedManagedProduct] = useState(null);
  // Tambahkan state baseProdName
  const [baseProdName, setBaseProdName] = useState("Nano SC"); // Default ke Nano SC
  // Tambahkan state untuk menyimpan produk terakhir yang dipilih saat pindah tipe
  const [lastSelectedProduct, setLastSelectedProduct] = useState("Nano SC");
  // Tambahkan state untuk config size (base specs VPS Custom)
  const [selectedConfigs, setSelectedConfigs] = useState({
    additional_cores: 2,
    additional_ram: 2,
    additional_space: 20
  });
  // Tambahkan state untuk menyimpan nama produk dengan App Catalog
  const [appCatalogProductName, setAppCatalogProductName] = useState(null);

  // Perbaiki currentProdName dengan fallback yang lebih baik - setelah vpsType didefinisikan
  const currentProdName = (() => {
    // console.log('🔍 currentProdName calculation:', { vpsType, prodsValue, appCatalogProductName, activeProdName: activeProd?.name, server, isManagedVPS });
    
    // Prioritas 1: Gunakan appCatalogProductName jika ada
    if (appCatalogProductName) {
      // console.log('🔍 Using appCatalogProductName:', appCatalogProductName);
      return appCatalogProductName;
    }
    
    // Prioritas 2: Untuk Managed VPS, prioritaskan prodsValue (dari dropdown) sebelum activeProd?.name
    // Ini mencegah currentProdName selalu reset ke PID URL
    if (isManagedVPS && prodsValue && 
        prodsValue !== "bundle" && 
        prodsValue !== "" && 
        prodsValue !== "Pilih Produk" &&
        prodsValue !== "Nano SC") {
      // console.log('🔍 Using prodsValue for Managed VPS:', prodsValue);
      return prodsValue;
    }
    
    // Prioritas 3: Gunakan activeProd?.name jika ada dan valid (kecuali untuk Managed VPS yang sudah punya prodsValue)
    if (activeProd?.name && activeProd.name !== "undefined" && activeProd.name !== "Loading...") {
      // Untuk Managed VPS, skip jika prodsValue sudah ada
      if (isManagedVPS && prodsValue && prodsValue !== "Nano SC") {
        // console.log('🔍 Skipping activeProd.name for Managed VPS, using prodsValue instead');
        // Fall through to prodsValue check
      } else {
      // console.log('🔍 Using activeProd.name:', activeProd.name);
      return activeProd.name;
      }
    }
    
    // Prioritas 4: Gunakan prodsValue dengan server name (untuk VPS non-Managed)
    if (prodsValue && 
        prodsValue !== "bundle" && 
        prodsValue !== "" && 
        prodsValue !== "Pilih Produk") {
      const serverName = server === 688 ? 'SouthJKT-1' : server === 697 ? 'SouthJKT-2' : server === 701 ? 'WestJavaBDG-1' : server === 725 ? 'USA' : '';
      
      // console.log('🔍 Prioritas 4 - prodsValue:', prodsValue, 'server:', server, 'serverName:', serverName);
      
      // Jika prodsValue adalah "Custom VPS", tampilkan sebagai Custom VPS
      if (prodsValue === "Custom VPS") {
        const customName = `Custom VPS (${serverName})`;
        // console.log('🔍 Using Custom VPS from prodsValue:', customName);
        return customName;
      }
      
      // Jika prodsValue adalah nama paket (Nano SC, SC1, dll), tampilkan sebagai Paket VPS
      const paketName = `${prodsValue} (${serverName})`;
      // console.log('🔍 Using Paket VPS from prodsValue:', paketName);
      return paketName;
    }
    
    // Prioritas 5: Gunakan vpsType sebagai fallback
    if (vpsType === "custom") {
      const customName = `Custom VPS (${server === 688 ? 'SouthJKT-1' : server === 697 ? 'SouthJKT-2' : server === 701 ? 'WestJavaBDG-1' : server === 725 ? 'USA' : 'Loading...'})`;
      // console.log('🔍 Prioritas 5 - Using Custom VPS from vpsType:', customName, 'server:', server);
      return customName;
    }
    
    // Prioritas 6: Default untuk VPS Paket
    const defaultName = `Nano SC (${server === 688 ? 'SouthJKT-1' : server === 697 ? 'SouthJKT-2' : server === 701 ? 'WestJavaBDG-1' : server === 725 ? 'USA' : 'Loading...'})`;
    // console.log('🔍 Using default Paket VPS:', defaultName);
    return defaultName;
  })();

  // Debug logging untuk currentProdName dan state initialization
  // console.log('🔍 State debug:', {
  //   queryPid: query.pid,
  //   vpsType,
  //   appCatalogProductName,
  //   activeProdName: activeProd?.name,
  //   prodsValue,
  //   server,
  //   currentProdName,
  //   vpsProductsGroupLength: vpsProductsGroup.length,
  //   priceByTermin,
  //   termin
  // });

  // Inisialisasi baseProdName saat load pertama kali - optimasi untuk menghindari delay
  useEffect(() => {
    if (currentProdName && currentProdName !== "Loading..." && currentName === null) {
      // Jika currentProdName dari activeProd, extract nama produk
      if (activeProd?.name) {
        const prodNamePrefix = activeProd.name.split(' ')[0]; // Ambil kata pertama
        setCurrentName(prodNamePrefix);
        // Jangan set prodsValue di sini, biarkan useEffect lain yang handle
        setBaseProdName(prodNamePrefix);
      } else {
        // Fallback ke prodsValue yang sudah ada
        const prodNamePrefix = prodsValue?.substr(0, 4).trim();
        setCurrentName(prodNamePrefix);
        setBaseProdName(prodNamePrefix);
      }
      setBundleValue({ forLabel: "", forValue: "empty" });
    }
  }, [currentProdName, currentName, activeProd?.name, prodsValue]);

  // Fetch product list once for App Catalog bundle search
  useEffect(() => {
    if (!productListCache) {
      fetch('https://stagingv8.portal.qwords.com/order/apis/getProducts.php?gid=688')
        .then(res => res.json())
        .then(json => {
          setProductListCache(json.products.product);
        });
    }
  }, [productListCache]);

  // fetch('https://stagingv8.portal.qwords.com/order/apis/getProducts.php?gid=688')
  //   .then(res => res.json())
  //   .then(json => {
  //     const names = json.products.product.map(prod => prod.name);
  //     console.log(names);
  // });


  const { total } = useSelector((state) => state.cart);

  const [vpsProduct, setVpsProduct] = useReducer(vpsReducer, {
    pid: +query.pid || 634,
    price: {},
    vpsDetails: null,
    promo: null,
  });

  // Debug logging untuk vpsProduct setelah didefinisikan
  // console.log('🔍 VPS Product debug:', {
  //   vpsProductPid: vpsProduct?.vpsDetails?.pid,
  //   vpsProductPrice: vpsProduct?.price,
  //   vpsProductDetails: vpsProduct?.vpsDetails
  // });

  // Inisialisasi baseProdName saat load pertama kali - optimasi untuk menghindari delay
  // useEffect(() => {
  //   if (currentProdName && currentProdName !== "Loading..." && currentName === null) {
  //     // Jika currentProdName dari activeProd, extract nama produk
  //     if (activeProd?.name) {
  //       const prodNamePrefix = activeProd.name.split(' ')[0]; // Ambil kata pertama
  //       setCurrentName(prodNamePrefix);
  //       // Jangan set prodsValue di sini, biarkan useEffect lain yang handle
  //       setBaseProdName(prodNamePrefix);
  //     } else {
  //       // Fallback ke prodsValue yang sudah ada
  //       const prodNamePrefix = prodsValue?.substr(0, 4).trim();
  //       setCurrentName(prodNamePrefix);
  //       setBaseProdName(prodNamePrefix);
  //     }
  //     setBundleValue({ forLabel: "", forValue: "empty" });
  //   }
  // }, [currentProdName, currentName, activeProd?.name, prodsValue]);

  // Inisialisasi prodsValue saat pertama kali load untuk VPS Paket - DIPERBAIKI untuk mencegah looping
  useEffect(() => {
    // console.log('🔍 Paket VPS initialization check - vpsType:', vpsType, 'prodsValue:', prodsValue, 'lastSelectedProduct:', lastSelectedProduct, 'query.pid:', query.pid);
    
    // Skip jika ada query.pid (biarkan useEffect deteksi Custom VPS yang handle)
    if (query.pid) {
      // console.log('🔍 Skipping Paket VPS initialization due to query.pid:', query.pid);
      return;
    }
    
    // Inisialisasi untuk VPS Paket jika prodsValue tidak valid
    if (vpsType === "paket" && (prodsValue === "" || prodsValue === "bundle" || !prodsValue || 
        prodsValue === "Pilih Produk" || prodsValue === "Custom" || prodsValue === "Custom VPS" || 
        prodsValue.includes("Custom"))) {
      const defaultProduct = lastSelectedProduct || "Nano SC";
      // console.log('🔍 Initializing prodsValue for paket - setting to:', defaultProduct, 'from invalid value:', prodsValue);
      setProdsValue(defaultProduct);
      setBaseProdName(defaultProduct);
      setLastSelectedProduct(defaultProduct);
    }
  }, [vpsType, lastSelectedProduct, prodsValue, query.pid]); // Tambahkan query.pid ke dependency

  // Deteksi tipe VPS berdasarkan query.pid (Custom VPS untuk PID 1159+)
  useEffect(() => {
    // console.log('🔍 Query PID detection useEffect - query.pid:', query.pid, 'isManualServerChange:', isManualServerChangeRef.current, 'isVpsTypeChanging:', isVpsTypeChangingRef.current);
    
    if (query.pid && !isManualServerChangeRef.current && !isVpsTypeChangingRef.current) {
      const pid = +query.pid;
      // console.log('🔍 Processing query.pid:', pid);
      
      if (pid >= 1159) {
        // PID 1159+ adalah Custom VPS
        // console.log('🔍 Query PID detected as Custom VPS:', pid, '- changing to custom type');
        setVpsType("custom");
        setProdsValue("Custom VPS");
        setBaseProdName("Custom VPS");
        setVpsPid(pid);
        setVpsProduct({ type: "SET_CURRENT_PID", payload: pid });
        
        // Set server berdasarkan PID untuk Custom VPS
        let serverFromPid = 688; // Default SouthJKT-1
        if (pid === 1159) serverFromPid = 688; // SouthJKT-1
        else if (pid === 1160) serverFromPid = 697; // SouthJKT-2
        else if (pid === 1161) serverFromPid = 701; // WestJavaBDG-1
        else if (pid === 1162) serverFromPid = 725; // USA
        
        if (server !== serverFromPid) {
          // console.log('🔍 Setting server from PID:', serverFromPid);
          setServer(serverFromPid);
        }
        
        // Inisialisasi vpsProduct untuk Custom VPS
        setVpsProduct({ 
          type: "SET_PRODUCT_DETAIL", 
          payload: {
            gid: serverFromPid,
            pid: pid,
            name: "Custom VPS",
            type: "vps",
            price: 0 // Harga akan di-update setelah data ter-load
          }
        });
        
        // Inisialisasi harga untuk Custom VPS berdasarkan termin
        const customVpsPrice = {
          monthly: 100000,
          quarterly: 300000,
          semiannually: 600000,
          annually: 1200000,
          biennially: 2400000,
          triennially: 3600000
        };
        
        setVpsProduct({ 
          type: "SET_PRODUCT_PRICE", 
          payload: customVpsPrice
        });
        
        // Pastikan flag manual server change di-reset untuk Custom VPS
        isManualServerChangeRef.current = false;
      } else {
        // PID di bawah 1159 adalah VPS Paket
        // console.log('🔍 Query PID detected as Paket VPS:', pid, '- setting Paket VPS values');
        setVpsType("paket");
      }
    } else {
      // console.log('🔍 Query PID detection skipped - conditions not met');
    }
  }, [query.pid, server]);

  // Inisialisasi dari query.pid menggunakan data dinamis dari API
  useEffect(() => {
    if (query.pid && vpsType === "paket" && vpsProductsGroup.length > 0) {
      // Cari produk berdasarkan PID dari data API yang sudah di-fetch
      const foundProduct = vpsProductsGroup.find(product => product.pid === +query.pid);
      if (foundProduct) {
        // Extract nama produk dari nama lengkap (misal: "SC16 USA" -> "SC16")
        let productName = foundProduct.name.split(' ')[0]; // Ambil kata pertama

        // Normalisasi casing untuk konsistensi
        if (productName.toLowerCase() === "nano") {
          productName = "Nano SC";
        }

        setProdsValue(productName);
        setBaseProdName(productName);
        setNoBundle(true);
      }
    }
  }, [query.pid, vpsType, vpsProductsGroup]);

  // Sinkronisasi prodsValue dengan currentProdName untuk auto-select dropdown - DISABLED untuk mencegah looping
  // useEffect(() => {
  //   if (currentProdName && currentProdName !== "Loading..." && vpsType === "paket") {
  //     // Extract nama produk dari currentProdName (misal: "SC16 USA" -> "SC16")
  //     let productName = currentProdName.split(' ')[0];

  //     // Normalisasi casing untuk konsistensi
  //     if (productName.toLowerCase() === "nano") {
  //       productName = "Nano SC";
  //     }

  //     // Cek apakah produk tersedia di vpsProductsGroup dan berbeda dengan prodsValue saat ini
  //     if (vpsProductsGroup.length > 0 && productName !== prodsValue) {
  //       const availableProducts = vpsProductsGroup.map(prod => {
  //         const prodName = prod.name.split(' ')[0];
  //         return prodName.toLowerCase() === "nano" ? "Nano SC" : prodName;
  //       });
  //       if (availableProducts.includes(productName)) {
  //         console.log('🔍 Syncing prodsValue with currentProdName:', productName);
  //         setProdsValue(productName);
  //         setBaseProdName(productName);
  //       }
  //     }
  //   }
  // }, [currentProdName, vpsType, vpsProductsGroup]); // Hapus prodsValue dari dependency untuk mencegah loop

  // Sinkronisasi prodsValue saat server berubah dan vpsProductsGroup ter-update - DISABLED untuk mencegah looping
  // useEffect(() => {
  //   if (vpsProductsGroup.length > 0 && vpsType === "paket" && prodsValue) {
  //     // Cek apakah prodsValue yang dipilih masih tersedia di server baru
  //     const availableProducts = vpsProductsGroup.map(prod => {
  //       const prodName = prod.name.split(' ')[0];
  //       return prodName.toLowerCase() === "nano" ? "Nano SC" : prodName;
  //     });

  //     if (!availableProducts.includes(prodsValue)) {
  //       // Jika produk tidak tersedia, pilih produk pertama yang tersedia (prioritaskan Nano SC)
  //       const nanoSCIndex = availableProducts.indexOf("Nano SC");
  //       const firstAvailableProduct = nanoSCIndex !== -1 ? "Nano SC" : availableProducts[0];
  //       if (firstAvailableProduct && firstAvailableProduct !== prodsValue) {
  //         console.log('🔍 Product not available, switching to:', firstAvailableProduct);
  //         setProdsValue(firstAvailableProduct);
  //         setBaseProdName(firstAvailableProduct);
  //       }
  //     }
  //   }
  // }, [vpsProductsGroup, vpsType]); // Hapus prodsValue dari dependency untuk mencegah loop



  const checkControlPanel = addonsVPS.filter(
    (item) =>
      item.category === "Software" && item.input_name === "Control Panel"
  );

  // Handler untuk perubahan OS/App dari selector
  // Fungsi mapping dinamis pencarian produk App Catalog
  function findAppCatalogProductPid(productList, currentProdName, appLabel) {
    let pattern = "";
    
    // Normalisasi nama produk untuk konsistensi
    let normalizedProdName = currentProdName;
    if (currentProdName.toLowerCase() === "nano") {
      normalizedProdName = "Nano SC";
    }
    
    switch (appLabel) {
      case "LEMP":
        pattern = `${normalizedProdName} DEBIAN 11 LEMP`;
        break;
      case "Moodle":
        pattern = `${normalizedProdName} Moodle`;
        break;
      case "aaPanel":
        pattern = `${normalizedProdName} Centos 7 + aaPanel`;
        break;
      case "CyberPanel":
        pattern = `${normalizedProdName} + Almalinux 8 CyberPanel`;
        break;
      case "PostgreSQL":
        pattern = `${normalizedProdName} + Postgre 14`;
        break;
      case "LAMP":
        pattern = `${normalizedProdName} + LAMP`;
        break;
      case "SISTER3":
        pattern = `${normalizedProdName} + Debian 8 Sister Risetdikti`;
        break;
      case "PDDIKTI Feeder":
        pattern = `${normalizedProdName} + PDDIKTI Feeder`;
        break;
      case "cPanel":
        pattern = `${normalizedProdName} + cPanel`;
        break;
      default:
        pattern = `${normalizedProdName} + ${appLabel}`;
    }
    
    // console.log('🔍 Searching App Catalog pattern:', pattern, 'for product:', normalizedProdName, 'app:', appLabel);
    
    // Cari produk yang namanya persis pattern, atau mengandung pattern
    const found = productList.find(prod => {
      const exactMatch = prod.name === pattern;
      const containsMatch = prod.name.includes(pattern);
      // console.log('🔍 Checking product:', prod.name, 'exact:', exactMatch, 'contains:', containsMatch);
      return exactMatch || containsMatch;
    });
    
    // console.log('🔍 App Catalog search result:', found ? found.pid : 'not found');
    return found ? found.pid : null;
  }

  const handleOsNameChange = useCallback((osName, osid, appInfo = null, osAddon = null) => {
    const newSelectedOsName = { os_name: osName, osid: osid, appInfo: appInfo, osAddon: osAddon };
    setSelectedOsName(newSelectedOsName);
    // console.log('productListCache', productListCache);

    // Jika App Catalog dipilih, cari produk bundle dengan mapping dinamis
    if (appInfo && appInfo.appLabel) {
      // Clear previous timer
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }

      // Debounce the actual product search
      debounceTimerRef.current = setTimeout(() => {
        if (productListCache && !isUpdatingPidRef.current) {
          // Gunakan prodsValue (produk yang dipilih dari dropdown) bukan baseProdName
          const selectedProduct = prodsValue || baseProdName;
          const pid = findAppCatalogProductPid(productListCache, selectedProduct, appInfo.appLabel);
          if (pid && pid !== vpsPid) { // Hanya update jika PID berbeda
            isUpdatingPidRef.current = true; // Set flag untuk mencegah konflik
            // console.log('🔍 App Catalog PID update:', pid, 'for app:', appInfo.appLabel, 'from selectedProduct:', selectedProduct);
            
            // Simpan nama produk App Catalog
            const appCatalogName = `${selectedProduct} + ${appInfo.appLabel}`;
            setAppCatalogProductName(appCatalogName);
            // console.log('🔍 Setting appCatalogProductName:', appCatalogName);
            
            setVpsPid(pid);
            setVpsProduct({ type: "SET_CURRENT_PID", payload: pid });
            
            // Reset flag setelah update selesai
            setTimeout(() => {
              isUpdatingPidRef.current = false;
            }, 100);
          }
        }
      }, 500); // 500ms delay
    } else {
      // Jika bukan App Catalog, kembalikan ke produk utama dari vpsProductsGroup (bukan dari currentProdName)
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
      if (vpsProductsGroup && vpsProductsGroup.length > 0 && !isUpdatingPidRef.current) {
        // Cari produk berdasarkan prodsValue (yang dipilih dari dropdown) bukan currentProdName
        const found = vpsProductsGroup.find(prod => {
          // Cek apakah nama produk mengandung prodsValue
          return prod.name.includes(prodsValue) && !prod.name.includes("Custom");
        });
        
        if (found && found.pid !== vpsPid) { // Hanya update jika PID berbeda
          isUpdatingPidRef.current = true; // Set flag untuk mencegah konflik
          // console.log('🔍 Normal PID update:', found.pid, 'for product:', found.name, 'from prodsValue:', prodsValue);
          
          // Reset App Catalog product name karena kembali ke produk normal
          setAppCatalogProductName(null);
          // console.log('🔍 Resetting appCatalogProductName to null');
          
          setVpsPid(found.pid);
          setVpsProduct({ type: "SET_CURRENT_PID", payload: found.pid });
          
          // Reset flag setelah update selesai
          setTimeout(() => {
            isUpdatingPidRef.current = false;
          }, 100);
        }
      }
    }
  }, [prodsValue, baseProdName, productListCache, vpsProductsGroup, vpsPid]); // Prioritaskan prodsValue

  // Handler untuk config size changes
  const handleConfigChange = useCallback((configs) => {
    setSelectedConfigs(configs);
  }, []);

  const checkSoftaculous = addonsVPS.filter(
    (item) => item.category === "Software" && item.input_name === "Softaculous"
  );

  const checkSupportLevel = addonsVPS.filter(
    (item) => item.category === "Support-Level"
  );

  const checkAdvancedBackup = addonsVPS.filter(
    (item) =>
      item.category === "Backup" &&
      (item.name.endsWith(currentProdName?.substr(0, 4).trim()) ||
        item.name.endsWith("Backup"))
  );

  const checkOthers = addonsVPS.filter((item) => item.category === "Others");


  const findOrigin = useCallback(() => {
    if (vpsProductsGroup.length !== 0) {
      // PENCEGAHAN: Skip jika ada query.pid dan PID sudah sesuai dengan query.pid
      if (query.pid && vpsPid === +query.pid) {
        return;
      }

      const itemName = buildProdName(prodsValue, bundleValue.forLabel);

      const temp = vpsProductsGroup.filter((vps) =>
        vps.name.includes(prodsValue)
      );
      const filteredProd = temp.filter(
        (v) => v.name.includes(itemName) && !v.name.includes("Snapshot")
      );

      if (filteredProd.length !== 0) {
        setVpsPid(+filteredProd[0].pid);
        setVpsProduct({ type: "SET_CURRENT_PID", payload: filteredProd[0].pid });
      }
    }
  }, [prodsValue, bundleValue.forLabel, vpsProductsGroup, query.pid, vpsPid]);

  // Hapus useEffect ini karena akan menyebabkan loop
  // useEffect(() => {
  //   findProductsGroup();
  // }, [findProductsGroup]);

  useEffect(() => {
    findOrigin();
  }, [findOrigin]);

  useEffect(() => {
    // console.log('🔍 activeGID sync - activeGID:', activeGID, 'server:', server, 'query.pid:', query.pid, 'isManualServerChange:', isManualServerChangeRef.current, 'isInitializing:', isInitializingRef.current);
    
    // Skip jika ada query.pid untuk Custom VPS (server sudah di-set berdasarkan PID)
    if (query.pid && +query.pid >= 1159) {
      // console.log('🔍 Skipping activeGID sync - Custom VPS with query PID');
      return;
    }
    
    if (activeGID !== 0 && server !== activeGID && !isManualServerChangeRef.current && !isInitializingRef.current) {
      // console.log('🔍 Syncing server to activeGID:', activeGID);
      setServer(activeGID);
    }
  }, [activeGID, server, query.pid]);

  // Inisialisasi server default - gunakan activeGID atau server pertama yang tersedia
  useEffect(() => {
    // console.log('🔍 Server initialization - activeGID:', activeGID, 'server:', server, 'query.pid:', query.pid);
    
    // Skip jika ada query.pid untuk Custom VPS (server akan di-set berdasarkan PID)
    if (query.pid && +query.pid >= 1159) {
      // console.log('🔍 Skipping server initialization - Custom VPS with query PID');
      return;
    }
    
    if (activeGID === 0 && server === 0) {
      // Set server default ke SouthJKT-1 (688) sebagai fallback
      // console.log('🔍 Setting default server to 688 (SouthJKT-1)');
      setServer(688);
    } else if (activeGID !== 0 && server === 0) {
      // Jika activeGID ada tapi server masih 0, set ke activeGID
      // console.log('🔍 Setting server to activeGID:', activeGID);
      setServer(activeGID);
    }
  }, [activeGID, server, query.pid]);

  // Fetch produk saat server berubah atau diinisialisasi
  useEffect(() => {
    // console.log('🔍 Server change effect - server:', server, 'query.pid:', query.pid, 'vpsType:', vpsType);
    
    // Skip fetch jika ada query.pid untuk Custom VPS (produk sudah di-fetch berdasarkan PID)
    if (query.pid && +query.pid >= 1159 && vpsType === "custom") {
      // console.log('🔍 Skipping server fetch - Custom VPS with query PID');
      return;
    }
    
    if (server !== 0) {
      // Fetch produk untuk server yang dipilih
      // console.log('🔍 Fetching VPS products for server:', server);
      dispatch(getVpsByServer(server));
    }
  }, [server, dispatch, query.pid, vpsType]);

  // Inisialisasi untuk Custom VPS - dengan debouncing untuk mencegah looping
  useEffect(() => {
    // console.log('🔍 Custom VPS useEffect triggered - vpsType:', vpsType, 'server:', server, 'vpsPid:', vpsPid, 'query.pid:', query.pid, 'isManualServerChange:', isManualServerChangeRef.current, 'isInitializing:', isInitializingRef.current);
    
    if (vpsType === "custom" && !isManualServerChangeRef.current && !isVpsTypeChangingRef.current) {
      // Jika ada query.pid, gunakan PID dari query (tidak override)
      if (query.pid && +query.pid >= 1159) {
        // console.log('🔍 Custom VPS - Using PID from query:', query.pid);
        if (vpsPid !== +query.pid) {
          setVpsPid(+query.pid);
          setVpsProduct({ type: "SET_CURRENT_PID", payload: +query.pid });
        }
        return; // Exit early untuk mencegah override dengan server-based PID
      }
      
      // Set VPS product untuk Custom VPS berdasarkan server (hanya jika tidak ada query.pid)
      let customPid = 1159; // Default SouthJKT-1
      if (server === 697) customPid = 1160; // SouthJKT-2
      else if (server === 701) customPid = 1161; // WestJavaBDG-1
      else if (server === 725) customPid = 1162; // USA

      // Hanya update jika PID berbeda untuk mencegah looping
      if (vpsPid !== customPid) {
        // console.log('🔍 Custom VPS - Setting PID from server:', customPid, 'for server:', server, 'current vpsPid:', vpsPid);
        setVpsPid(customPid);
        setVpsProduct({ type: "SET_CURRENT_PID", payload: customPid });
      } else {
        // console.log('🔍 Custom VPS - PID already correct:', customPid);
      }
    } else {
      // console.log('🔍 Custom VPS - Conditions not met:', {
      //   vpsTypeIsCustom: vpsType === "custom",
      //   notManualServerChange: !isManualServerChangeRef.current,
      //   notVpsTypeChanging: !isVpsTypeChangingRef.current
      // });
    }
  }, [vpsType, server, vpsPid, query.pid]);

  useEffect(() => {
    if (firstLoad.current) {
      if (!query.pid) {
        dispatch(getProduct(vpsProduct.pid));
        setChangeProduct(!changeProduct);
      } else {
        setNoBundle(true);
        setVpsPid(+query?.pid ?? +vpsProduct.pid);
      }

      if (query.billingcycle) {
        setTermin(query.billingcycle);
      }

      // Reset flag inisialisasi setelah load pertama kali selesai
      setTimeout(() => {
        // console.log('🔍 Resetting isInitializingRef to false');
        isInitializingRef.current = false;
      }, 1000);
    }
    snapshotRef.current = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let mount = true;
    if (vpsPid && mount) {
      // Skip untuk Managed VPS karena sudah di-handle langsung di onChange handler
      if (isManagedVPS) {
        return;
      }
      
      // Untuk Custom VPS, selalu fetch meskipun ada flag manual server change
      // Untuk Paket VPS, skip jika ada flag manual server change
      const shouldFetch = vpsType === "custom" || !isManualServerChangeRef.current;
      
      if (shouldFetch) {
        // console.log('🔍 Fetching addons for vpsPid:', vpsPid, 'vpsType:', vpsType, 'shouldFetch:', shouldFetch);
        dispatch(getAddonsVPS(vpsPid));
        // Hanya fetch product jika vpsPid berbeda dengan current product untuk menghindari fetch berulang
        if (vpsPid !== activeProd?.pid) {
          // console.log('🔍 Fetching product for vpsPid:', vpsPid);
          dispatch(getProduct(vpsPid));
        }
      } else {
        // console.log('🔍 SKIPPING fetch - vpsType:', vpsType, 'isManualServerChange:', isManualServerChangeRef.current);
      }
    }

    return () => {
      mount = false;
    };
  }, [dispatch, vpsPid, activeProd?.pid, vpsType, isManagedVPS]);

  // Fetch produk Managed VPS dari gid 734
  useEffect(() => {
    if (isManagedVPS && managedVpsProducts.length === 0) {
      fetch(`${process.env.REACT_APP_BASE_API}order/apis/getProducts.php?gid=734`)
        .then(res => res.json())
        .then(json => {
          if (json.result === "success" && json.products && json.products.product) {
            const products = Array.isArray(json.products.product) 
              ? json.products.product 
              : [json.products.product];
            setManagedVpsProducts(products);
            
            // Auto-select produk pertama jika belum ada yang dipilih
            if (!selectedManagedProduct && products.length > 0) {
              const firstProduct = products[0];
              setSelectedManagedProduct(firstProduct.pid);
              setVpsPid(firstProduct.pid);
              setVpsProduct({ type: "SET_CURRENT_PID", payload: firstProduct.pid });
              
              // Update product name untuk ditampilkan
              setProdsValue(firstProduct.name);
              setBaseProdName(firstProduct.name);
              setCurrentName(firstProduct.name);
              
              // Fetch product dan addons untuk Managed VPS
              dispatch(getProduct(firstProduct.pid));
              dispatch(getAddonsVPS(firstProduct.pid));
            }
          }
        })
        .catch(error => {
          console.error("Error fetching Managed VPS products:", error);
        });
    }
  }, [isManagedVPS, managedVpsProducts.length, selectedManagedProduct, dispatch]);

  // Auto-select CloudLinux OS dan addon untuk Managed VPS
  useEffect(() => {
    if (isManagedVPS && addonsVPS && addonsVPS.length > 0 && !selectedOsName.osAddon) {
      // Cari CloudLinux addon
      const cloudlinuxAddon = addonsVPS.find(addon => 
        addon.input_name === "Operating System" && 
        addon.name === "Operating System - CloudLinux OS"
      );
      
      if (cloudlinuxAddon) {
        // Set OS ke CloudLinux
        setSelectedType("os");
        setSelectedOsOrApp("cloudlinux");
        setSelectedVersion("8"); // Default versi 8
        
        // Set OS name dan addon
        const osName = "cloudlinux-8-x86_64";
        setSelectedOsName({
          os_name: osName,
          osid: null,
          osAddon: cloudlinuxAddon
        });
        
        // Jangan dispatch addVpsAddons di sini karena produk belum ada di cart
        // Addon akan ditambahkan saat produk ditambahkan ke cart di addToCartHandler
      }
      
      // Auto-select DirectAdmin Personal Plus (default ID 157) untuk Managed VPS
      if (!currentPanel && !selectedManagedPanel) {
        // Cari DirectAdmin Personal Plus (ID 157) sebagai default
        const directadminPersonalPlus = addonsVPS.find(addon => 
          addon.input_name === "Control Panel" && 
          addon.id === 157
        );
        
        if (directadminPersonalPlus) {
          setSelectedManagedPanel(directadminPersonalPlus.id);
          setCurrentPanel(directadminPersonalPlus);
          // Jangan dispatch addVpsAddons di sini karena produk belum ada di cart
          // Addon akan ditambahkan saat produk ditambahkan ke cart di addToCartHandler
        }
      }
      
      // Auto-select Immunify 360 Single Hosting Account (default ID 117) untuk Managed VPS
      if (!selectedManagedImmunify) {
        const immunifySingle = addonsVPS.find(addon => 
          addon.input_name === "Immunify" && 
          addon.id === 117
        );
        
        if (immunifySingle) {
          setSelectedManagedImmunify(immunifySingle.id);
          // Jangan dispatch addVpsAddons di sini karena produk belum ada di cart
          // Addon akan ditambahkan saat produk ditambahkan ke cart di addToCartHandler
        }
      }
    }
  }, [isManagedVPS, addonsVPS, selectedOsName.osAddon, currentPanel, selectedManagedPanel, selectedManagedProduct, selectedManagedImmunify]);

  useEffect(() => {
    let isMounted = true;

    // PENCEGAHAN LOOPING: Skip jika sedang ada PID update yang sedang berlangsung
    if (isUpdatingPidRef.current) {
      // console.log('🔍 SKIPPING - PID update in progress, preventing loop');
      return;
    }

    if (isMounted && vpsProductsGroup.length !== 0 && vpsType === "paket") {
      
      // console.log('🔍 useEffect triggered - vpsPid:', vpsPid, 'prodsValue:', prodsValue, 'currentProdName:', currentProdName);
      
      // PENCEGAHAN LOOPING: Jika prodsValue adalah "Custom", "Custom VPS", atau kosong, skip processing
      if (prodsValue === "Custom" || prodsValue === "Custom VPS" || prodsValue.includes("Custom") || 
          prodsValue === "" || prodsValue === "bundle" || !prodsValue || prodsValue === "Pilih Produk") {
        // console.log('🔍 SKIPPING - prodsValue is invalid:', prodsValue, 'waiting for state to be corrected');
        return;
      }

      // PENCEGAHAN: Skip jika ada query.pid dan PID sudah sesuai dengan query.pid
      if (query.pid && vpsPid === +query.pid) {
        // console.log('🔍 SKIPPING - PID already matches query.pid:', query.pid);
        return;
      }

      // PENCEGAHAN: Skip jika sedang ada perubahan server manual
      if (isManualServerChangeRef.current) {
        // console.log('🔍 SKIPPING - Manual server change in progress');
        return;
      }

      // PENCEGAHAN: Skip jika sedang ada PID update (App Catalog atau OS change)
      if (isUpdatingPidRef.current) {
        // console.log('🔍 SKIPPING - PID update in progress');
        return;
      }

      // PENCEGAHAN: Skip jika sedang ada perubahan tipe VPS
      if (isVpsTypeChangingRef.current) {
        // console.log('🔍 SKIPPING - VPS type change in progress');
        return;
      }

      // PENCEGAHAN: Skip jika currentProdName mengandung App Catalog (sudah dipilih App Catalog)
      if (currentProdName && currentProdName.includes('+')) {
        // console.log('🔍 SKIPPING - currentProdName contains App Catalog, preventing override:', currentProdName);
        return;
      }

      // PENCEGAHAN: Skip jika PID saat ini adalah App Catalog PID (PID 950-999 adalah App Catalog)
      if (vpsPid && vpsPid >= 950 && vpsPid <= 999) {
        // console.log('🔍 SKIPPING - Current PID is App Catalog PID, preventing override:', vpsPid);
        return;
      }

      // PENCEGAHAN: Skip jika vpsPid adalah null dan sedang dalam proses reset
      if (vpsPid === null && (isManualServerChangeRef.current || isVpsTypeChangingRef.current)) {
        // console.log('🔍 SKIPPING - vpsPid is null and system is resetting');
        return;
      }

      // PENCEGAHAN: Skip jika perubahan terlalu cepat (dalam 200ms)
      const now = Date.now();
      if (now - lastChangeTimeRef.current < 200) {
        // console.log('🔍 SKIPPING - Change too fast, preventing rapid updates');
        return;
      }
      lastChangeTimeRef.current = now;
      
      // Filter produk yang bukan Custom VPS dan sesuai dengan prodsValue
      const getProducts = vpsProductsGroup.filter((item) => {
        // Exclude Custom VPS products
        if (item.name.toLowerCase().includes('custom') || 
            item.name.toLowerCase().includes('vps custom') ||
            item.pid >= 1159) { // Custom VPS PIDs: 1159, 1160, 1161, 1162
          return false;
        }
        return item.name.includes(prodsValue);
      });
      
      
      // old code
      const getProduct = getProducts[0];
      // const getProduct = getProducts.find((item) => item.pid === currentProdId);
      const trueProduct = getProducts.find(
        (item) => item.name === currentProdName
      );

      // console.log("trueProduct", trueProduct);
      // console.log("getProduct", getProduct);

      let targetPid = null;
      if (trueProduct?.pid) {
        targetPid = trueProduct?.pid;
      } else if (getProduct?.pid) {
        targetPid = getProduct?.pid;
      }

      // Hanya update jika PID berbeda untuk mencegah looping
      // TAMBAHAN: Cek apakah ini perubahan App Catalog yang valid
      if (targetPid && targetPid !== vpsPid) {
        // Cek apakah currentProdName mengandung App Catalog (misal: "SC1 + Almalinux 8 CyberPanel")
        const isAppCatalogChange = currentProdName && currentProdName.includes('+');
        
        // PENCEGAHAN: Jangan override App Catalog jika sudah dipilih
        if (selectedOsName.appInfo && selectedOsName.appInfo.appLabel) {
          // console.log('🔍 SKIPPING - App Catalog already selected, preventing override. Current PID:', vpsPid, 'Target PID:', targetPid);
          return;
        }
        
        // PENCEGAHAN: Jangan override jika currentProdName mengandung App Catalog
        if (currentProdName && currentProdName.includes('+')) {
          // console.log('🔍 SKIPPING - currentProdName contains App Catalog, preventing override. Current:', currentProdName);
          return;
        }
        
        // Jika ini perubahan App Catalog, pastikan tidak looping
        if (isAppCatalogChange) {
          // Debounce untuk perubahan App Catalog
          if (debounceTimerRef.current) {
            clearTimeout(debounceTimerRef.current);
          }
          
          debounceTimerRef.current = setTimeout(() => {
            if (!isUpdatingPidRef.current) {
              isUpdatingPidRef.current = true; // Set flag untuk mencegah konflik
              // console.log('🔍 Setting new PID (App Catalog):', targetPid, 'from prodsValue:', prodsValue);
              setVpsProduct({ type: "SET_CURRENT_PID", payload: targetPid });
              setVpsPid(targetPid);
              
              // Reset flag setelah update selesai
              setTimeout(() => {
                isUpdatingPidRef.current = false;
              }, 100);
            }
          }, 100); // Debounce 100ms untuk App Catalog
        } else {
          // Untuk perubahan normal (bukan App Catalog), langsung update
          if (!isUpdatingPidRef.current) {
            isUpdatingPidRef.current = true; // Set flag untuk mencegah konflik
            // console.log('🔍 Setting new PID (Normal):', targetPid, 'from prodsValue:', prodsValue);
            setVpsProduct({ type: "SET_CURRENT_PID", payload: targetPid });
            setVpsPid(targetPid);
            
            // Reset flag setelah update selesai
            setTimeout(() => {
              isUpdatingPidRef.current = false;
            }, 100);
          }
        }
      }

      // if (getProduct === undefined) {
      //   window.location.reload();
      // }
      snapshotRef.current = false;
    }

    return () => (isMounted = false);
  }, [vpsProductsGroup, prodsValue, currentProdName, vpsType, vpsPid, query.pid, selectedOsName.appInfo]); // Tambahkan selectedOsName.appInfo untuk pengecekan App Catalog

  // useEffect khusus untuk menangani perubahan server manual
  useEffect(() => {
    if (isManualServerChangeRef.current && vpsProductsGroup.length > 0 && vpsType === "paket" && !vpsPid) {
      // Cari produk yang sesuai dengan prodsValue di server baru
      const getProducts = vpsProductsGroup.filter((item) => {
        // Exclude Custom VPS products
        if (item.name.toLowerCase().includes('custom') || 
            item.name.toLowerCase().includes('vps custom') ||
            item.pid >= 1159) {
          return false;
        }
        return item.name.includes(prodsValue);
      });

      if (getProducts.length > 0) {
        const foundProduct = getProducts[0];
        // console.log('🔍 Manual server change - setting PID:', foundProduct.pid, 'for product:', foundProduct.name);
        setVpsPid(foundProduct.pid);
        setVpsProduct({ type: "SET_CURRENT_PID", payload: foundProduct.pid });
      }
    }
  }, [vpsProductsGroup, prodsValue, vpsType, vpsPid]);

  useEffect(() => {
    if (vpsProductsGroup.length > 0) {
      vpsProductsGroup.forEach((prods) => {
        if (vpsProduct.pid === prods.pid) {
          setVpsProduct({
            type: "SET_PRODUCT_PRICE",
            payload: prods.pricing.IDR,
          });
          setVpsProduct({
            type: "SET_PRODUCT_DETAIL",
            payload: {
              pid: prods.pid,
              gid: prods.gid,
              name: prods.name,
              type: prods.type,
              billingcycle: termin,
              price: +priceByTermin,
            },
          });
          if (prods.promo) {
            setVpsProduct({
              type: "SET_PROMO",
              payload: {
                pid: prods.pid,
                realprice: prods.realprice,
                appliesto: prods.promo.appliesto,
                description: prods.promo.description,
                price: prods.promo.price,
                type: prods.promo.type,
                promocode: prods.promocode,
              },
            });
          }
        }
      });
    }
  }, [vpsProductsGroup, vpsProduct.pid, priceByTermin, termin]);

  useEffect(() => {
    // Untuk Managed VPS, ambil harga langsung dari activeProd.pricing.IDR[termin]
    if (isManagedVPS && activeProd?.pricing?.IDR?.[termin]) {
      const priceFromAPI = parseFloat(activeProd.pricing.IDR[termin]);
      if (priceFromAPI && priceFromAPI !== -1) {
        setPriceByTermin(priceFromAPI);
      } else {
        setPriceByTermin(0);
      }
      setDelBundlePrice(0);
      setBundlePrice(0);
      return;
    }

    // Untuk VPS biasa, gunakan vpsProduct.price
    // Pastikan vpsProduct.price ada sebelum mengakses propertinya
    if (!vpsProduct.price) {
      setPriceByTermin(0);
      setDelBundlePrice(0);
      setBundlePrice(0);
      return;
    }

    switch (termin) {
      case "triennially":
        setPriceByTermin(vpsProduct.price.triennially || 0);
        // setDelBundlePrice(320000 * 36);
        // setBundlePrice(85000 * 36);
        break;
      case "biennially":
        setPriceByTermin(vpsProduct.price.biennially || 0);
        // setDelBundlePrice(320000 * 24);
        // setBundlePrice(85000 * 24);
        break;
      case "annually":
        setPriceByTermin(vpsProduct.price.annually || 0);
        // setDelBundlePrice(320000 * 12);
        // setBundlePrice(85000 * 12);
        break;
      case "quarterly":
        setPriceByTermin(vpsProduct.price.quarterly || 0);
        // setDelBundlePrice(320000 * 6);
        // setBundlePrice(85000 * 6);
        break;
      case "semiannually":
        setPriceByTermin(vpsProduct.price.semiannually || 0);
        // setDelBundlePrice(320000 * 3);
        // setBundlePrice(85000 * 3);
        break;
      case "monthly":
        setPriceByTermin(vpsProduct.price.monthly || 0);
        // setDelBundlePrice(320000);
        // setBundlePrice(85000);
        break;
      default:
        setPriceByTermin(0);
        setDelBundlePrice(0);
        setBundlePrice(0);
        break;
    }
  }, [vpsProduct, termin, isManagedVPS, activeProd?.pricing?.IDR]);

  const getFilteredVpsProducts = useCallback((serverId) => {
    if (vpsProductsGroup.length === 0) {
      return vpsProductInit; // Fallback ke hardcoded jika data belum loaded
    }

    // Gunakan data dinamis dari vpsProductsGroup - exclude Custom VPS
    const dynamicProducts = vpsProductsGroup
      .filter(product => {
        // Exclude Custom VPS products by PID and name
        if (product.pid >= 1159 || // Custom VPS PIDs: 1159, 1160, 1161, 1162
            product.name.toLowerCase().includes('custom') ||
            product.name.toLowerCase().includes('vps custom')) {
          return false;
        }
        return true;
      })
      .map(product => {
      const productName = product.name.split(' ')[0]; // Extract nama produk

      // Normalisasi casing untuk menghindari duplikat
      let normalizedName = productName;
      if (productName.toLowerCase() === "nano") {
        normalizedName = "Nano SC"; // Pastikan konsisten dengan "Nano SC"
      }

      return {
        value: normalizedName,
        label: normalizedName,
        pid: product.pid
      };
    });

    // Hapus duplikat berdasarkan value (nama produk) dengan case-insensitive
    const uniqueProducts = dynamicProducts.filter((product, index, self) =>
      index === self.findIndex(p => p.value.toLowerCase() === product.value.toLowerCase())
    );

    // Sort produk berdasarkan urutan yang diinginkan - Nano SC selalu pertama
    const productOrder = ["Nano SC", "SC1", "SC2", "SC4", "SC8", "SC16", "SC32", "SC64"];
    const sortedProducts = uniqueProducts.sort((a, b) => {
      const indexA = productOrder.indexOf(a.value);
      const indexB = productOrder.indexOf(b.value);

      // Jika tidak ada di order, taruh di akhir
      if (indexA === -1 && indexB === -1) return a.value.localeCompare(b.value);
      if (indexA === -1) return 1;
      if (indexB === -1) return -1;

      return indexA - indexB;
    });

    // Filter untuk server USA - hapus produk yang tidak tersedia
    if (serverId === 725) {
      return sortedProducts.filter(product =>
        !["Nano SC", "SC32", "SC64", "SC1"].includes(product.value)
      );
    }

    // Hapus "Custom" dari dropdown untuk tipe Paket
    return sortedProducts.filter(product =>
      product.value !== "Custom" &&
      product.value.toLowerCase() !== "custom"
    );
  }, [vpsProductsGroup]);

  // Fungsi untuk mendapatkan pilihan produk berdasarkan tipe VPS
  const getVpsProductOptions = () => {
    if (vpsType === "paket") {
      // Untuk VPS Paket: tampilkan produk dari data dinamis
      const options = getFilteredVpsProducts(server);
      return options;
    } else {
      // Untuk VPS Custom: tidak perlu dropdown, langsung return empty array
      return [];
    }
  };

  const changeVpsProductHandler = useCallback((e) => {
    const selectedValue = e.target.value;

    // Hanya untuk VPS Paket
    if (vpsType === "paket") {
      // PENCEGAHAN: Jangan izinkan "Custom" atau "Custom VPS" dipilih sebagai produk paket
      if (selectedValue === "Custom" || selectedValue === "Custom VPS" || selectedValue.includes("Custom")) {
        notifyWarning("Custom VPS tidak tersedia untuk tipe Paket. Silakan pilih produk paket yang tersedia.");
        return;
      }

      if (server === 725) {
        const restrictedProducts = ["Nano SC", "SC32", "SC64", "SC1"];
        if (restrictedProducts.includes(selectedValue)) {
          notifyWarning(`${selectedValue} tidak tersedia untuk lokasi server USA`);
          return;
        }
      }

      // Hanya update jika nilai benar-benar berubah
      if (selectedValue === prodsValue) return;

      setProdsValue(selectedValue);
      setBaseProdName(selectedValue);
      // Simpan produk yang dipilih sebagai produk terakhir
      setLastSelectedProduct(selectedValue);

      // Reset states yang diperlukan saja
      setBundleValue({ forLabel: "", forValue: "empty" });
      setCurrentPanel(false);
      setCurrentSupport(false);
      setCurrentSoftaculous(false);
      setCurrentOthers(false);
      setCurrentBackup(false);
      setBundlePromo("choose");
      setCurrentBundlingPanel(0);
      setSelectedVersion("");
      setAppCatalogProductName(null); // Reset App Catalog product name

      // Reset config size saat produk berubah (ke base specs)
      setSelectedConfigs({
        additional_cores: 2,
        additional_ram: 2,
        additional_space: 20
      });

      // Reset OS selection saat produk berubah
      setSelectedType("os");
      setSelectedOsOrApp("choose");
      setSelectedOsName({ os_name: "", osid: null, osAddon: null });

      // Reset VPS product untuk memastikan config options terupdate
      setVpsProduct({ type: "RESET_PRODUCT" });
      setVpsPid(null); // Reset PID juga

    }
  }, [vpsType, server, prodsValue]);

  // Handler untuk perubahan server - optimasi untuk performa
  const handleServerChange = useCallback((newServerId) => {
    if (newServerId !== server) {
      // console.log('🔍 handleServerChange - Changing server from', server, 'to', newServerId, 'vpsType:', vpsType);
      
      // Set flag untuk mencegah konflik dengan useEffect lain
      isManualServerChangeRef.current = true;
      setServer(newServerId);

      // Reset states yang diperlukan saja
      setBundleValue({ forLabel: "", forValue: "empty" });
      setCurrentPanel(false);
      setCurrentSupport(false);
      setCurrentSoftaculous(false);
      setCurrentOthers(false);
      setCurrentBackup(false);
      setBundlePromo("choose");
      setCurrentBundlingPanel(0);
      setSelectedVersion("");
      setAppCatalogProductName(null); // Reset App Catalog product name
      setSelectedType("os");
      setSelectedOsOrApp("choose");
      setSelectedOsName({ os_name: "", osid: null, osAddon: null });
      setSelectedConfigs({
        additional_cores: 2,
        additional_ram: 2,
        additional_space: 20
      });

      // Untuk Custom VPS, update PID berdasarkan server baru
      if (vpsType === "custom") {
        let newCustomPid = 1159; // Default SouthJKT-1
        if (newServerId === 697) newCustomPid = 1160; // SouthJKT-2
        else if (newServerId === 701) newCustomPid = 1161; // WestJavaBDG-1
        else if (newServerId === 725) newCustomPid = 1162; // USA
        
        // console.log('🔍 handleServerChange - Setting Custom VPS PID:', newCustomPid, 'for server:', newServerId);
        setVpsPid(newCustomPid);
        setVpsProduct({ type: "SET_CURRENT_PID", payload: newCustomPid });
      } else {
        // Untuk Paket VPS, reset PID untuk memaksa fetch produk baru
      setVpsProduct({ type: "RESET_PRODUCT" });
        setVpsPid(null);
      }

      // Fetch products untuk server baru
      if (newServerId !== activeGID) {
        dispatch(getVpsByServer(newServerId));
      }

      // Reset flag setelah perubahan server selesai dengan delay yang lebih lama
      setTimeout(() => {
        isManualServerChangeRef.current = false;
        // console.log('🔍 handleServerChange - Flag reset completed');
      }, 300);
    }
  }, [server, dispatch, activeGID, vpsType]);

  // Handler untuk perubahan tipe VPS (Paket vs Custom) - DIPERBAIKI untuk mencegah looping
  const changeVpsTypeHandler = useCallback((e) => {
    const newVpsType = e.target.value;
    
    // Hanya update jika tipe benar-benar berubah
    if (newVpsType === vpsType) {
      return;
    }
    
    // console.log('🔍 changeVpsTypeHandler - Switching from', vpsType, 'to', newVpsType);
    
    // PENCEGAHAN LOOPING: Set flag dan state secara synchronous untuk menghindari race condition
    isVpsTypeChangingRef.current = true;
    // Hanya set flag manual server change untuk paket, bukan untuk custom
    if (newVpsType === "paket") {
      isManualServerChangeRef.current = true;
    }
    setVpsType(newVpsType);

    // Set prodsValue secara langsung berdasarkan tipe baru
    if (newVpsType === "paket") {
      // Gunakan lastSelectedProduct atau fallback ke Nano SC
      let productToRestore = lastSelectedProduct || "Nano SC";
      
      // console.log('🔍 changeVpsTypeHandler - Setting paket values:', productToRestore);
      setProdsValue(productToRestore);
      setBaseProdName(productToRestore);
      setLastSelectedProduct(productToRestore);
    } else {
      // console.log('🔍 changeVpsTypeHandler - Setting custom values');
      setProdsValue("Custom VPS");
      setBaseProdName("Custom VPS");
    }

    // Reset semua state saat tipe berubah
    setBundleValue({ forLabel: "", forValue: "empty" });
    setCurrentPanel(false);
    setCurrentSupport(false);
    setCurrentSoftaculous(false);
    setCurrentOthers(false);
    setCurrentBackup(false);
    setBundlePromo("choose");
    setCurrentBundlingPanel(0);
    setSelectedVersion("");
    setAppCatalogProductName(null); // Reset App Catalog product name
    setSelectedType("os");
    setSelectedOsOrApp("choose");
    setSelectedOsName({ os_name: "", osid: null, osAddon: null });
    setSelectedConfigs({
      additional_cores: 2,
      additional_ram: 2,
      additional_space: 20
    });

    // Reset VPS product dengan delay untuk mencegah race condition
    setVpsProduct({ type: "RESET_PRODUCT" });
    setVpsPid(null); // Reset PID juga

    // Set server default berdasarkan tipe
    if (newVpsType === "paket") {
      // console.log('🔍 changeVpsTypeHandler - Setting server for paket:', activeGID || 688);
      setServer(activeGID || 688); // Default ke SouthJKT-1
    } else {
      // Untuk custom, set ke server pertama yang tersedia
      // console.log('🔍 changeVpsTypeHandler - Setting server for custom:', activeGID || 688);
      setServer(activeGID || 688); // Default ke SouthJKT-1
    }
    
    // Reset flag setelah perubahan tipe selesai dengan delay yang lebih lama
    setTimeout(() => {
      isVpsTypeChangingRef.current = false;
      if (newVpsType === "paket") {
        isManualServerChangeRef.current = false;
      }
      // console.log('🔍 changeVpsTypeHandler - Flags reset completed');
    }, 500);
    
  }, [vpsType, activeGID, lastSelectedProduct]); // Hapus currentProdName dan vpsProductsGroup untuk mencegah looping

  const changeTerminHandler = (e) => {
    const terminValue = e.target.value;
    setTermin(terminValue);

    const notIncludePID = [
      "1010",
      "1024",
      "1031",
      "1038",
      "1045",
      "1052",
      "1059",
      "1066",
    ];
    const startDate = new Date("2024-08-17T07:00:00+07:00");
    const endDate = new Date("2024-08-25T07:00:00+07:00");
    const currentDate = new Date();

    const isWithinPromoPeriod =
      currentDate >= startDate && currentDate < endDate;

    const shouldApplyPromo =
      activeGID !== 5 &&
      activeGID !== 708 &&
      activeGID !== 709 &&
      activeGID !== 712 &&
      activeGID !== 721 &&
      !notIncludePID.includes(query.pid) &&
      location.pathname !== "/paymentmethod" &&
      location.pathname !== "/orderesummary" &&
      !query.promocode &&
      isWithinPromoPeriod;

    if (shouldApplyPromo) {
      dispatch(
        getProductsPromoVPS({
          gid: activeGID,
          pid: vpsProduct.vpsDetails.pid,
          billingcycle: terminValue,
          promocode: "DISKON45",
        })
      );
    }

    // Update OS addon jika ada OS yang dipilih
    if (selectedOsName.osAddon) {
      const osAddon = selectedOsName.osAddon;
      const newOsPrice = osAddon && osAddon[terminValue] ? (osAddon[terminValue] === "-1.00" ? 0 : parseFloat(osAddon[terminValue]) || 0) : 0;
      
      // Update Redux state untuk OS addon dengan termin baru
      if (newOsPrice > 0) {
        dispatch(addVpsAddons({ pid: vpsProduct.pid, addons: osAddon }));
      } else {
        dispatch(removeVpsAddons({ pid: vpsProduct.pid, input: "Operating System" }));
      }
    }

    setTimeout(() => {
      if (currentPanel)
        dispatch(addVpsAddons({ pid: vpsProduct.pid, addons: currentPanel }));
      if (currentBackup)
        dispatch(addVpsAddons({ pid: vpsProduct.pid, addons: currentBackup }));
      if (currentSupport)
        dispatch(addVpsAddons({ pid: vpsProduct.pid, addons: currentSupport }));
      if (currentSoftaculous)
        dispatch(
          addVpsAddons({ pid: vpsProduct.pid, addons: currentSoftaculous })
        );
      if (currentOthers)
        dispatch(addVpsAddons({ pid: vpsProduct.pid, addons: currentOthers }));
      if (bundlePromo !== "choose") {
        const addonItem = addonsVPS?.find((item) => item.id === +180) ?? null;
        // if (addonItem) {
        //   dispatch(addVpsAddons({ pid: pidOnCart, addons: addonItem }));
        // }
        dispatch(removeVpsAddons({ pid: pidOnCart, addons: addonItem }));
      }
    }, 200);
  };

  const changePasswordHandler = () => {
    const password = passwordRef?.current?.value;
    const {
      title = null,
      score = 0,
      variant,
    } = checkPasswordStrength(password) ?? {};
    setPasswordStrength({ title, variant, score: score * 20 });
  };

  const validateHostname = (hostname) => {
    // Reset error message
    setHostnameError("");
    
    if (!hostname || hostname.trim() === "") {
      setHostnameError("Hostname tidak boleh kosong");
      return false;
    }

    // Check total length (max 255 characters)
    if (hostname.length > 255) {
      setHostnameError("Hostname tidak boleh lebih dari 255 karakter");
      return false;
    }

    // Check for invalid characters (@, spaces, special characters except hyphen and dot)
    const invalidChars = /[@\s!@#$%^&*()+=\[\]{};':"\\|,<>\/?~`]/;
    if (invalidChars.test(hostname)) {
      setHostnameError("Hostname tidak boleh mengandung karakter khusus seperti @, spasi, atau simbol");
      return false;
    }

    // Split hostname by dots to check each label
    const labels = hostname.split('.');
    
    for (let i = 0; i < labels.length; i++) {
      const label = labels[i];
      
      // Check if label is empty
      if (label === "") {
        setHostnameError("Hostname tidak boleh mengandung titik berturut-turut atau di awal/akhir");
        return false;
      }
      
      // Check label length (max 63 characters per label)
      if (label.length > 63) {
        setHostnameError("Setiap bagian hostname tidak boleh lebih dari 63 karakter");
        return false;
      }
      
      // Check if label starts or ends with hyphen
      if (label.startsWith('-') || label.endsWith('-')) {
        setHostnameError("Setiap bagian hostname tidak boleh dimulai atau diakhiri dengan tanda hubung (-)");
        return false;
      }
      
      // Check if label contains only valid characters (a-z, A-Z, 0-9, -)
      const validLabelPattern = /^[a-zA-Z0-9-]+$/;
      if (!validLabelPattern.test(label)) {
        setHostnameError("Hostname hanya boleh mengandung huruf (a-z, A-Z), angka (0-9), dan tanda hubung (-)");
        return false;
      }
    }

    // Check if hostname starts or ends with dot
    if (hostname.startsWith('.') || hostname.endsWith('.')) {
      setHostnameError("Hostname tidak boleh dimulai atau diakhiri dengan titik");
      return false;
    }

    return true;
  };

  const handleHostnameChange = (e) => {
    const hostnameValue = e.target.value;
    validateHostname(hostnameValue);
  };

  const toggleVisibilityHandler = () => {
    if (passwordRef.current.type === "password") {
      passwordRef.current.type = "text";
      peekIconRef.current.src = NoPeek;
    } else {
      passwordRef.current.type = "password";
      peekIconRef.current.src = Peek;
    }
  };


  useEffect(() => {
    if (vpsProduct && vpsProduct.vpsDetails) {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }
  }, [vpsProduct]);

  const addToCartHandler = useCallback(() => {
    // Basic validation checks
    if (!vpsProduct || !vpsProduct.vpsDetails) {
      notifyWarning("Produk belum siap, silahkan tunggu sebentar.");
      return;
    }

    if (!hostnameRef.current?.value || !passwordRef.current?.value) {
      notifyWarning("Silahkan isi hostname dan password terlebih dahulu.");
      return;
    }

    // Validate hostname before proceeding
    const hostnameValue = hostnameRef.current.value;
    if (!validateHostname(hostnameValue)) {
      notifyError("Hostname tidak valid. " + hostnameError);
      return;
    }

    if (passwordStrength.score < 40) {
      notifyError("Password anda terlalu lemah, coba lagi!");
      return;
    }

    // Validasi khusus untuk Custom VPS - wajib memilih OS
    if (vpsType === "custom" && (!selectedOsName.os_name || selectedOsName.os_name === "")) {
      notifyWarning("Untuk Custom VPS, silahkan pilih Operating System terlebih dahulu.");
      return;
    }

    // Validasi khusus untuk Managed VPS - wajib memilih Panel dan Immunify
    if (isManagedVPS) {
      if (!selectedManagedPanel) {
        notifyWarning("Silahkan pilih Panel terlebih dahulu.");
        return;
      }
      if (!selectedManagedImmunify) {
        notifyWarning("Silahkan pilih Immunify terlebih dahulu.");
        return;
      }
    }

    // Prepare VPS details
    const hostname = hostnameValue;
    const password = passwordRef.current.value;

    setVpsProduct({
      type: "SET_HOSTNAME_PASSWORD",
      payload: { hostname, password }
    });

    const updatedVpsDetails = {
      ...vpsProduct.vpsDetails,
      hostname,
      password
    };

    // Process if product is ready
    if (currentProduct.status === "idle" && vpsProduct.vpsDetails) {
      // Get OS details and price - gunakan addon yang dipilih dari VpsOsAppSelector
      let getOS = null;
      let getOsPrice = 0;

      if (selectedOsName.osAddon) {
        // Gunakan addon yang dipilih dari selector
        getOS = selectedOsName.osAddon;
        getOsPrice = getOS && getOS[termin] ? (getOS[termin] === "-1.00" ? 0 : parseFloat(getOS[termin]) || 0) : 0;
      } else {
        // Fallback ke cara lama jika tidak ada addon yang dipilih
        getOS = vpsProduct.vpsDetails.vpsaddons?.find(
          (addons) => addons.input_name === "Operating System"
        );
        getOsPrice = getOS && getOS[termin] ? (+getOS[termin] === -1 ? 0 : +getOS[termin]) : 0;
      }

      // Check OS requirement for noBundle (mengacu ke VpsOsAppSelector)
      if (noBundle && (!selectedOsName.os_name || selectedOsName.os_name === "")) {
        notifyWarning("Silahkan pilih OS dan versi terlebih dahulu.");
        return;
      }

      // Check if product already exists in cart - PINDAHKAN KE ATAS
      const existingProduct = productsList.find(product => product.pid === vpsProduct.vpsDetails.pid);

      // Build customfields langsung di sini
      const osCustomField = activeProd?.customfields?.customfield?.find(
        field => field.name === "Operating System"
      );
      const appCustomField = activeProd?.customfields?.customfield?.find(
        field => field.name === "Application" || field.name === "App"
      );

      const customfields = [];

      // HAPUS SEMUA OS CUSTOMFIELD YANG ADA SEBELUMNYA untuk memastikan update yang bersih
      if (existingProduct && existingProduct.customfields) {
        const existingCustomfields = existingProduct.customfields.filter(field => {
          return !osCustomField || field.id !== osCustomField.id;
        });
        customfields.push(...existingCustomfields);
      }

      // TAMBAHKAN OS CUSTOMFIELD YANG BARU DIPILIH
      if (osCustomField && selectedOsName.os_name) {
        // Gunakan nama OS yang konsisten dengan addon
        let osValue = selectedOsName.os_name;

        // Jika ada osAddon, gunakan nama dari addon untuk konsistensi
        if (selectedOsName.osAddon && selectedOsName.osAddon.name) {
          // Extract OS name dari addon name (e.g., "Operating System - CloudLinux OS" -> "cloudlinux-8-x86_64")
          const addonName = selectedOsName.osAddon.name;
          if (addonName.includes("CloudLinux")) {
            // Untuk CloudLinux, gunakan format yang konsisten
            if (selectedOsName.os_name.includes("cloudlinux-8")) {
              osValue = "cloudlinux-8-x86_64";
            } else if (selectedOsName.os_name.includes("cloudlinux-9")) {
              osValue = "cloudlinux-9-x86_64";
            }
          }
        }

        customfields.push({ id: osCustomField.id, value: osValue });
      }

      // Tambahkan App customfield jika ada appInfo
      if (appCustomField && selectedOsName.appInfo && selectedOsName.appInfo.app) {
        customfields.push({ id: appCustomField.id, value: selectedOsName.appInfo.appLabel || selectedOsName.appInfo.app });
      }

      // Handle bundle promo
      if (bundlePromo !== "choose") {
        const bundlePanelMap = {
          "Plesk + Cloudlinux + Immunify": 92,
          "ISPManager Lite + ImmunifyAV": 191,
          "DirectAdmin + Cloudlinux + Immunify": 157
        };

        const panelId = bundlePanelMap[bundlePromo];
        if (panelId) {
          setCurrentBundlingPanel(panelId);
        }
      }

      // Add promo if applicable
      if (vpsProduct.promo && vpsProduct.vpsDetails.pid === vpsProduct.promo.pid) {
        dispatch(addPromo(vpsProduct.promo));
      }

      // Prepare vpsaddons - preserve existing ones and add OS, Panel, and Immunify if needed
      let vpsaddons = existingProduct?.vpsaddons ? [...existingProduct.vpsaddons] : [];

      // Tambahkan OS addon ke cart jika ada
      if (getOS) {
        // HAPUS SEMUA OS ADDON YANG ADA SEBELUMNYA untuk memastikan update yang bersih
        vpsaddons = vpsaddons.filter(addon => addon.input_name !== "Operating System");

        // TAMBAHKAN OS ADDON YANG BARU DIPILIH
        vpsaddons.push(getOS);

        // Handle Redux state berdasarkan harga
        if (getOsPrice > 0) {
          // Jika OS berbayar, tambahkan ke Redux state
          dispatch(addVpsAddons({ pid: vpsProduct.vpsDetails.pid, addons: getOS }));
        } else {
          // Jika OS gratis, hapus dari Redux state
          dispatch(removeVpsAddons({ pid: vpsProduct.vpsDetails.pid, input: "Operating System" }));
        }
      } else {
        // Jika tidak ada OS yang dipilih, hapus dari vpsaddons
        vpsaddons = vpsaddons.filter(addon => addon.input_name !== "Operating System");
      }

      // Untuk Managed VPS, tambahkan Control Panel dan Immunify dari dropdown
      if (isManagedVPS && addonsVPS && addonsVPS.length > 0) {
        // Tambahkan Control Panel jika dipilih
        if (selectedManagedPanel) {
          const panelAddon = addonsVPS.find(addon => 
            addon.id === selectedManagedPanel && 
            addon.input_name === "Control Panel"
          );
          
          if (panelAddon) {
            // HAPUS SEMUA CONTROL PANEL ADDON YANG ADA SEBELUMNYA
            vpsaddons = vpsaddons.filter(addon => addon.input_name !== "Control Panel");
            
            // TAMBAHKAN CONTROL PANEL ADDON YANG BARU DIPILIH
            vpsaddons.push(panelAddon);
            
            // Tambahkan ke Redux state
            dispatch(addVpsAddons({ pid: vpsProduct.vpsDetails.pid, addons: panelAddon }));
          }
        }

        // Tambahkan Immunify jika dipilih
        if (selectedManagedImmunify) {
          const immunifyAddon = addonsVPS.find(addon => 
            addon.id === selectedManagedImmunify && 
            addon.input_name === "Immunify"
          );
          
          if (immunifyAddon) {
            // HAPUS SEMUA IMMUNIFY ADDON YANG ADA SEBELUMNYA
            vpsaddons = vpsaddons.filter(addon => addon.input_name !== "Immunify");
            
            // TAMBAHKAN IMMUNIFY ADDON YANG BARU DIPILIH
            vpsaddons.push(immunifyAddon);
            
            // Tambahkan ke Redux state
            dispatch(addVpsAddons({ pid: vpsProduct.vpsDetails.pid, addons: immunifyAddon }));
          }
        }
      } else {
        // Untuk VPS biasa (non-Managed), tambahkan Control Panel jika ada
        if (currentPanel) {
          // HAPUS SEMUA CONTROL PANEL ADDON YANG ADA SEBELUMNYA
          vpsaddons = vpsaddons.filter(addon => addon.input_name !== "Control Panel");
          
          // TAMBAHKAN CONTROL PANEL ADDON YANG BARU DIPILIH
          vpsaddons.push(currentPanel);
          
          // Tambahkan ke Redux state
          dispatch(addVpsAddons({ pid: vpsProduct.vpsDetails.pid, addons: currentPanel }));
        }
      }

      // Hitung total harga dengan benar - pastikan konversi ke number
      // Untuk Managed VPS, ambil harga langsung dari activeProd.pricing.IDR[termin]
      let basePrice = 0;
      if (isManagedVPS && activeProd?.pricing?.IDR?.[termin]) {
        const priceFromAPI = parseFloat(activeProd.pricing.IDR[termin]);
        basePrice = priceFromAPI && priceFromAPI !== -1 ? priceFromAPI : 0;
      } else {
        basePrice = parseFloat(priceByTermin || vpsProduct.vpsDetails.price || 0);
      }
      const osPrice = parseFloat(getOsPrice || 0);

      // Hitung harga config options menggunakan data langsung dari database
      let configPrice = 0;
      let configoptions = [];

      if (activeProd?.configoptions?.configoption) {
        activeProd.configoptions.configoption.forEach(option => {
          if (option.name === 'additional_cores') {
            // Base specs (2 Core) gratis, hanya tambahan yang berbayar
            if (selectedConfigs.additional_cores > 2) {
              // Hitung additional cores (total - base)
              const additionalCores = selectedConfigs.additional_cores - 2;
              
              // Cari opsi yang sesuai dengan nilai ADDITIONAL yang dipilih
              // Database menyimpan additional cores di optionname
              const selectedOption = option.options.option.find(opt => 
                parseInt(opt.name) === additionalCores
              );
              
              if (selectedOption) {
                const optionPrice = selectedOption.pricing.IDR[termin];
                if (optionPrice && optionPrice !== "-1.00") {
                  const totalPrice = parseFloat(optionPrice);
                configPrice += totalPrice;

                configoptions.push({
                  id: option.id,
                    value: selectedOption.id, // Gunakan ID dari database
                  name: `Additional CPU Cores (+${additionalCores} Core)`,
                  price: totalPrice
                });
                }
              }
            }
          }

          if (option.name === 'additional_ram') {
            // Base specs (2GB RAM) gratis, hanya tambahan yang berbayar
            if (selectedConfigs.additional_ram > 2) {
              // Hitung additional RAM (total - base)
              const additionalRam = selectedConfigs.additional_ram - 2;
              
              // Cari opsi yang sesuai dengan nilai ADDITIONAL yang dipilih (dalam MB)
              // Database menyimpan additional RAM dalam MB
              const additionalRamInMB = additionalRam * 1024;
              const selectedOption = option.options.option.find(opt => 
                parseInt(opt.name) === additionalRamInMB
              );
              
              if (selectedOption) {
                const optionPrice = selectedOption.pricing.IDR[termin];
                if (optionPrice && optionPrice !== "-1.00") {
                  const totalPrice = parseFloat(optionPrice);
                configPrice += totalPrice;

                configoptions.push({
                  id: option.id,
                    value: selectedOption.id, // Gunakan ID dari database
                  name: `Additional RAM (+${additionalRam} GB)`,
                  price: totalPrice
                });
                }
              }
            }
          }

          if (option.name === 'additional_space') {
            // Base specs (20GB Storage) gratis, hanya tambahan yang berbayar
            if (selectedConfigs.additional_space > 20) {
              // Hitung additional storage (total - base)
              const additionalSpace = selectedConfigs.additional_space - 20;
              
              // Cari opsi yang sesuai dengan nilai ADDITIONAL yang dipilih
              // Database menyimpan additional storage dalam GB
              const selectedOption = option.options.option.find(opt => 
                parseInt(opt.name) === additionalSpace
              );
              
              if (selectedOption) {
                const optionPrice = selectedOption.pricing.IDR[termin];
                if (optionPrice && optionPrice !== "-1.00") {
                  const totalPrice = parseFloat(optionPrice);
                configPrice += totalPrice;

                configoptions.push({
                  id: option.id,
                    value: selectedOption.id, // Gunakan ID dari database
                  name: `Additional Storage (+${additionalSpace} GB)`,
                  price: totalPrice
                });
                }
              }
            }
          }
        });
      }

      const totalPrice = basePrice + osPrice + configPrice;

      // Pastikan name termasuk server location untuk VPS Custom
      // Untuk Managed VPS, gunakan prodsValue atau currentProdName
      let productName;
      if (isManagedVPS && prodsValue && prodsValue !== "Nano SC") {
        productName = prodsValue;
      } else if (vpsType === "custom") {
        productName = `Custom VPS (${server === 688 ? 'SouthJKT-1' : server === 697 ? 'SouthJKT-2' : server === 701 ? 'WestJavaBDG-1' : server === 725 ? 'USA' : 'Unknown'})`;
      } else {
        productName = updatedVpsDetails.name;
      }

      const productData = {
        ...updatedVpsDetails,
        name: productName, // Update name dengan server location
        price: basePrice, // Harga base tetap Rp149.000
        priceWithAddon: totalPrice, // Total harga termasuk addons untuk display
        configoptions: configoptions, // Gunakan configoptions yang sudah dihitung
        customfields,
        vpsaddons: vpsaddons, // Tambahkan vpsaddons ke data produk
        billingcycle: termin // Pastikan billing cycle ter-include
      };

      // Debug logging untuk memastikan server location tersimpan
      // console.log('🛒 Adding to cart - productData:', {
      //   pid: productData.pid,
      //   gid: productData.gid,
      //   name: productData.name,
      //   server: server,
      //   serverName: server === 688 ? 'SouthJKT-1' : server === 697 ? 'SouthJKT-2' : server === 701 ? 'WestJavaBDG-1' : server === 725 ? 'USA' : 'Unknown'
      // });


      if (existingProduct) {
        // Update existing product to preserve addons
        dispatch(changeProductFromCart(productData));
        notifySuccess("Produk berhasil diperbarui di keranjang.");
      } else {
        // Add new product
        dispatch(addToCart(productData));
        notifySuccess("Produk berhasil ditambahkan ke keranjang. Silahkan pilih addons yang anda butuhkan.");
      }
    }
  }, [
    vpsProduct,
    currentProduct.status,
    activeProd?.pricing?.IDR,
    isManagedVPS,
    hostnameRef,
    passwordRef,
    passwordStrength.score,
    vpsType, // tambahkan dependensi vpsType untuk validasi Custom VPS
    termin,
    priceByTermin, // tambahkan dependensi priceByTermin
    noBundle,
    bundlePromo,
    activeProd.customfields,
    activeProd.configoptions, // tambahkan dependensi configoptions
    productsList,
    dispatch,
    selectedOsName.os_name, // dependensi baru
    selectedOsName.appInfo, // dependensi untuk app catalog
    selectedOsName.osAddon, // dependensi untuk addon OS
    selectedConfigs, // tambahkan dependensi selectedConfigs
    server, // tambahkan dependensi server untuk debug logging
    isManagedVPS, // dependensi untuk Managed VPS
    addonsVPS, // dependensi untuk addons VPS
    selectedManagedPanel, // dependensi untuk Managed VPS Panel
    selectedManagedImmunify, // dependensi untuk Managed VPS Immunify
    currentPanel, // dependensi untuk Control Panel (VPS biasa)
    prodsValue // dependensi untuk product name (Managed VPS)
  ]);

  const changeBundlePromoHandler = (e) => {
    // Validasi: cek apakah ada produk di cart
    if (productsList.length === 0) {
      notifyWarning("Silahkan tambahkan produk VPS ke keranjang terlebih dahulu sebelum memilih Promo Bundle.");
      // Reset dropdown ke "choose"
      e.target.value = "choose";
      return;
    }

    if (productsList.length > 0 && e.target.value !== "choose") {
      if (e.target.value === "ISPManager Lite + ImmunifyAV") {
        setBundlePromo(e.target.value);
        setCurrentBundlingPanel(191);
        setHargaBundle(
          checkControlPanel?.find((item) => item.id === 191)?.[termin]
        );
      } else if (e.target.value === "Plesk + Cloudlinux + Immunify") {
        setBundlePromo(e.target.value);
        setCurrentBundlingPanel(92);
        setHargaBundle(
          checkControlPanel?.find((item) => item.id === 92)?.[termin]
        );
      } else if (e.target.value === "DirectAdmin + Cloudlinux + Immunify") {
        setBundlePromo(e.target.value);
        setCurrentBundlingPanel(157);
        setHargaBundle(
          checkControlPanel?.find((item) => item.id === 157)?.[termin]
        );
      }
      // const addonItem = addonsVPS?.find((item) => item.id === +180) ?? null;
      // dispatch(removeVpsAddons({ pid: pidOnCart, addons: addonItem }));
    } else {
      setBundlePromo("choose");
      setHargaBundle(0);
      setCurrentBundlingPanel(0); // Reset bundling panel to trigger removal
      dispatch(removeVpsAddons({ pid: pidOnCart, input: "Others" }));
      dispatch(removeVpsAddons({ pid: pidOnCart, input: "Control Panel" })); // Remove Control Panel addon
    }
  };

  useEffect(() => {
    const nanoScSlugs = [
      "nano-sc",
      "nano-sc-southjkt-2",
      "nano-sc-westjavabdg-1",
      "sc1",
      "sc1-southjkt-2",
      "sc1-westjavabdg-1",
      "sc2",
      "sc2-southjkt-2",
      "sc2-westjavabdg-1",
      "sc4",
      "sc4-southjkt-2",
      "sc4-westjavabdg-1",
      "sc8",
      "sc8-southjkt-2",
      "sc8-westjavabdg-1",
      "sc16",
      "sc16-southjkt-2",
      "sc16-westjavabdg-1",
      "sc32",
      "sc32-southjkt-2",
      "sc32-westjavabdg-1",
      "sc64",
      "sc64-southjkt-2",
      "sc64-westjavabdg-1",
    ];

    if (nanoScSlugs.includes(activeProd.slug)) {
      setNoBundle(true);
    } else {
      setNoBundle(false);
    }
  }, [activeProd]);

  useEffect(() => {
    if (bundleValue.forLabel === "empty") {
      setNoBundle(true);
    } else {
      setNoBundle(false);
    }
  }, [bundleValue.forLabel]);

  // useEffect(() => {
  //   if (location.pathname === "/ordervps" && !query.pid && vpsType === "paket") {
  //     setProdsValue("Nano SC");
  //     setNoBundle(true);
  //   }
  // }, [location.pathname, query.pid, vpsType]);

  useEffect(() => {
    if (vpsProduct?.vpsDetails?.vpsaddons) {
      const checkAddonsOS = vpsProduct.vpsDetails.vpsaddons.find(
        (list) =>
          list.name === "Operating System - CentOS" ||
          list.name === "Operating System - Almalinux" ||
          list.name === "Operating System - Ubuntu" ||
          list.name === "Operating System - CloudLinux OS"
      );

      if (productsList) {
        const checkProduct = productsList.find(
          (list) => list.type === "server"
        );
        if (checkProduct) {
          const checkAddonsPanel = checkProduct.vpsaddons.find(
            (list) => list.input_name === "Control Panel"
          );
          const checkCartAddons = checkProduct.vpsaddons.find(
            (list) =>
              list.name === "Operating System - CentOS" ||
              list.name === "Operating System - Almalinux" ||
              list.name === "Operating System - Ubuntu" ||
              list.name === "Operating System - CloudLinux OS"
          );
          if (
            (checkAddonsOS && checkAddonsPanel) ||
            (checkCartAddons && checkAddonsPanel)
          ) {
            setIsSoftaculous(true);
          } else {
            setIsSoftaculous(false);
          }
        }
      }
    }
  }, [
    vpsProduct,
    productsList,
  ]);

  useEffect(() => {
    const pidPromoSsl = [
      1010, 1024, 1031, 1038, 1045, 1052, 1059, 1066,
      634, 956, 635, 890, 891, 684, 685, 850, 964, 851, 874, 875
    ];
    const gidPromoSsl = [
      710, 713, 715, 717, 711, 714, 716, 718, 688, 697, 701
    ];

    setShowPromoBundling(!pidPromoSsl.includes(vpsPid) && gidPromoSsl.includes(activeGID));
  }, [vpsPid, activeGID]);

  useEffect(() => {
    const notIncludePID = [
      "1010", "1024", "1031", "1038", "1045", "1052", "1059", "1066"
    ];
    const startDate = new Date("2024-08-17T07:00:00+07:00");
    const endDate = new Date("2024-08-25T07:00:00+07:00");
    const currentDate = new Date();
    const isWithinPromoPeriod = currentDate >= startDate && currentDate < endDate;

    const shouldApplyPromo =
      activeGID !== 5 &&
      activeGID !== 708 &&
      activeGID !== 709 &&
      activeGID !== 712 &&
      activeGID !== 721 &&
      !notIncludePID.includes(query.pid) &&
      location.pathname !== "/paymentmethod" &&
      location.pathname !== "/orderesummary" &&
      !query.promocode &&
      isWithinPromoPeriod;

    if (shouldApplyPromo) {
      if (query.pid) {
        setShowPromo(true);
        dispatch(setQueryPromo("DISKON45"));
        dispatch(getProductsPromoVPS({
          gid: activeGID,
          pid: query.pid,
          billingcycle: query.billingcycle,
          promocode: "DISKON45",
        }));
      } else if (vpsProduct?.vpsDetails?.pid !== vpsProduct?.promo?.pid) {
        dispatch(setQueryPromo("DISKON45"));
        dispatch(getProductsPromoVPS({
          gid: activeGID,
          pid: vpsProduct?.vpsDetails?.pid,
          billingcycle: termin,
          promocode: "DISKON45",
        }));
      }
    } else if (query.promocode) {
      dispatch(setQueryPromo(query.promocode));
    } else {
      dispatch(setQueryPromo(null));
      dispatch(removePromoCode());
    }
  }, [
    activeGID,
    query.pid,
    query.billingcycle,
    query.promocode,
    location.pathname,
    vpsProduct?.vpsDetails?.pid,
    vpsProduct?.promo?.pid,
    termin,
    dispatch
  ]);

  // useEffect(() => {
  //   if (currentProduct.status === "idle" && vpsProduct?.vpsDetails) {
  //     const updatedVpsDetails = {
  //       ...vpsProduct.vpsDetails,
  //       hostname: hostnameRef.current?.value,
  //       password: passwordRef.current?.value,
  //     };

  //     // HAPUS LOGIKA LAMA - sudah diganti dengan logika yang lebih baik di bawah

  //     if (vpsProduct.promo &&
  //       vpsProduct.vpsDetails.pid === vpsProduct.promo.pid &&
  //       productsList.length > 0) {
  //       dispatch(addPromo(vpsProduct.promo));
  //     }

  //     // Get existing product to preserve addons
  //     const existingProduct = productsList.find(product => product.pid === vpsProduct.vpsDetails.pid);

  //     // Prepare vpsaddons - preserve existing ones and add OS if needed
  //     let vpsaddons = existingProduct?.vpsaddons ? [...existingProduct.vpsaddons] : [];

  //     // Gunakan addon yang dipilih dari VpsOsAppSelector jika ada
  //     let getOS = null;
  //     let getOsPrice = 0;
  //     if (selectedOsName.osAddon) {
  //       getOS = selectedOsName.osAddon;
  //       getOsPrice = getOS && getOS[termin] ? (getOS[termin] === "-1.00" ? 0 : parseFloat(getOS[termin]) || 0) : 0;
  //     } else {
  //       getOS = vpsProduct.vpsDetails.vpsaddons?.find(
  //         (addons) => addons.input_name === "Operating System"
  //       );
  //       getOsPrice = getOS && getOS[termin] ? (+getOS[termin] === -1 ? 0 : +getOS[termin]) : 0;
  //     }

  //     // Tambahkan atau hapus OS addon ke cart berdasarkan harga
  //     if (getOS) {
  //       // HAPUS SEMUA OS ADDON YANG ADA SEBELUMNYA untuk memastikan update yang bersih
  //       vpsaddons = vpsaddons.filter(addon => addon.input_name !== "Operating System");

  //       // TAMBAHKAN OS ADDON YANG BARU DIPILIH
  //       vpsaddons.push(getOS);

  //       // Handle Redux state berdasarkan harga
  //       if (getOsPrice > 0) {
  //         // Jika OS berbayar, tambahkan ke Redux state
  //         dispatch(addVpsAddons({ pid: vpsProduct.vpsDetails.pid, addons: getOS }));
  //       } else {
  //         // Jika OS gratis, hapus dari Redux state
  //         dispatch(removeVpsAddons({ pid: vpsProduct.vpsDetails.pid, input: "Operating System" }));
  //       }
  //     } else {
  //       // Jika tidak ada OS yang dipilih, hapus dari vpsaddons
  //       vpsaddons = vpsaddons.filter(addon => addon.input_name !== "Operating System");
  //     }

  //     // Prepare customfields - preserve existing ones and add OS if needed
  //     let customfields = [];
  //     if (existingProduct && existingProduct.customfields) {
  //       customfields = [...existingProduct.customfields];
  //     }

  //     // HAPUS SEMUA OS CUSTOMFIELD YANG ADA SEBELUMNYA untuk memastikan update yang bersih
  //     const osCustomField = activeProd.customfields.customfield.find(
  //       field => field.name === "Operating System"
  //     );
  //     if (osCustomField) {
  //       customfields = customfields.filter(field => field.id !== osCustomField.id);
  //     }

  //     // TAMBAHKAN OS CUSTOMFIELD YANG BARU DIPILIH
  //     if (selectedOsName.os_name && osCustomField) {
  //       // Gunakan nama OS yang konsisten dengan addon
  //       let osValue = selectedOsName.os_name;

  //       // Jika ada osAddon, gunakan nama dari addon untuk konsistensi
  //       if (selectedOsName.osAddon && selectedOsName.osAddon.name) {
  //         // Extract OS name dari addon name (e.g., "Operating System - CloudLinux OS" -> "cloudlinux-8-x86_64")
  //         const addonName = selectedOsName.osAddon.name;
  //         if (addonName.includes("CloudLinux")) {
  //           // Untuk CloudLinux, gunakan format yang konsisten
  //           if (selectedOsName.os_name.includes("cloudlinux-8")) {
  //             osValue = "cloudlinux-8-x86_64";
  //           } else if (selectedOsName.os_name.includes("cloudlinux-9")) {
  //             osValue = "cloudlinux-9-x86_64";
  //           }
  //         }
  //       }

  //       customfields.push({
  //         id: osCustomField.id,
  //         value: osValue
  //       });
  //     }

  //     // Hitung total harga dengan benar - pastikan konversi ke number
  //     const basePrice = parseFloat(priceByTermin || vpsProduct.vpsDetails.price || 0);
  //     const osPrice = parseFloat(getOsPrice || 0);

  //     // Hitung harga config options menggunakan data langsung dari database
  //     let configPrice = 0;
  //     let configoptions = [];

  //     if (activeProd?.configoptions?.configoption) {
  //       activeProd.configoptions.configoption.forEach(option => {
  //         if (option.name === 'additional_cores') {
  //           // Base specs (2 Core) gratis, hanya tambahan yang berbayar
  //           if (selectedConfigs.additional_cores > 2) {
  //             // Cari opsi yang sesuai dengan nilai TOTAL yang dipilih
  //             // Database menyimpan total cores di optionname
  //             const selectedOption = option.options.option.find(opt => 
  //               parseInt(opt.name) === selectedConfigs.additional_cores
  //             );
              
  //             if (selectedOption) {
  //               const optionPrice = selectedOption.pricing.IDR[termin];
  //               if (optionPrice && optionPrice !== "-1.00") {
  //                 const totalPrice = parseFloat(optionPrice);
  //               configPrice += totalPrice;

  //               configoptions.push({
  //                 id: option.id,
  //                   value: selectedOption.id, // Gunakan ID dari database
  //                 name: `Additional CPU Cores (+${selectedConfigs.additional_cores - 2} Core)`,
  //                 price: totalPrice
  //               });
  //               }
  //             }
  //           }
  //         }

  //         if (option.name === 'additional_ram') {
  //           // Base specs (2GB RAM) gratis, hanya tambahan yang berbayar
  //           if (selectedConfigs.additional_ram > 2) {
  //             // Cari opsi yang sesuai dengan nilai TOTAL yang dipilih (dalam MB)
  //             // Database menyimpan total RAM dalam MB
  //             const totalRamInMB = selectedConfigs.additional_ram * 1024;
  //             const selectedOption = option.options.option.find(opt => 
  //               parseInt(opt.name) === totalRamInMB
  //             );
              
  //             if (selectedOption) {
  //               const optionPrice = selectedOption.pricing.IDR[termin];
  //               if (optionPrice && optionPrice !== "-1.00") {
  //                 const totalPrice = parseFloat(optionPrice);
  //               configPrice += totalPrice;

  //               configoptions.push({
  //                 id: option.id,
  //                   value: selectedOption.id, // Gunakan ID dari database
  //                 name: `Additional RAM (+${selectedConfigs.additional_ram - 2} GB)`,
  //                 price: totalPrice
  //               });
  //               }
  //             }
  //           }
  //         }

  //         if (option.name === 'additional_space') {
  //           // Base specs (20GB Storage) gratis, hanya tambahan yang berbayar
  //           if (selectedConfigs.additional_space > 20) {
  //             // Cari opsi yang sesuai dengan nilai TOTAL yang dipilih
  //             // Database menyimpan total storage dalam GB
  //             const selectedOption = option.options.option.find(opt => 
  //               parseInt(opt.name) === selectedConfigs.additional_space
  //             );
              
  //             if (selectedOption) {
  //               const optionPrice = selectedOption.pricing.IDR[termin];
  //               if (optionPrice && optionPrice !== "-1.00") {
  //                 const totalPrice = parseFloat(optionPrice);
  //               configPrice += totalPrice;

  //               configoptions.push({
  //                 id: option.id,
  //                   value: selectedOption.id, // Gunakan ID dari database
  //                 name: `Additional Storage (+${selectedConfigs.additional_space - 20} GB)`,
  //                 price: totalPrice
  //               });
  //               }
  //             }
  //           }
  //         }
  //       });
  //     }

  //     const totalPrice = basePrice + osPrice + configPrice;

  //     const productDataToSend = {
  //       ...updatedVpsDetails,
  //       priceWithAddon: totalPrice,
  //       configoptions: configoptions, // Gunakan configoptions yang sudah dihitung
  //       customfields: customfields,
  //       vpsaddons: vpsaddons // Tambahkan vpsaddons ke data produk
  //     };

  //     dispatch(changeProductFromCart(productDataToSend));
  //   }
  // }, [
  //   currentProduct.status,
  //   vpsProduct?.vpsDetails,
  //   vpsProduct?.promo,
  //   productsList,
  //   termin,
  //   priceByTermin, // tambahkan dependensi priceByTermin
  //   activeProd.customfields,
  //   activeProd.configoptions, // tambahkan dependensi configoptions
  //   hostnameRef,
  //   passwordRef,
  //   dispatch,
  //   selectedOsName.osAddon, // dependensi untuk addon OS
  //   selectedOsName.os_name, // dependensi untuk nama OS
  //   selectedOsName.osid, // dependensi untuk OS ID
  //   selectedConfigs // tambahkan dependensi selectedConfigs
  // ]);

  // Update customfields setiap kali OS/versi dipilih - DIPERBAIKI untuk mencegah infinite loop
  useEffect(() => {
    // Ambil customfield Operating System dari produk aktif
    const osCustomField = activeProd?.customfields?.customfield?.find(
        field => field.name === "Operating System"
      );
    // Value customfield harus persis value os_name dari VpsOsAppSelector
    const osValue = selectedOsName;

    if (osCustomField && osValue) {
      // Hanya update jika ada perubahan yang signifikan
      const currentOsField = customfields.find(field => field.id === osCustomField.id);
      if (!currentOsField || currentOsField.value !== osValue) {
        let newCustomfields = customfields.filter(field => field.id !== osCustomField.id);
      newCustomfields.push({ id: osCustomField.id, value: osValue });
    setCustomfields(newCustomfields);
      }
    }
    // eslint-disable-next-line
  }, [selectedOsOrApp, selectedVersion, selectedOsName, activeProd, selectedOsName.osAddon]); // Hapus customfields dari dependency

  // Reset OS selection jika config berubah (untuk menyembunyikan App Catalog) - DISABLED untuk mencegah OS tereset
  // useEffect(() => {
  //   // Cek apakah ada config yang di atas base specs (2 Core, 2 GB, 20 GB)
  //   const hasCustomConfig = selectedConfigs.additional_cores > 2 ||
  //     selectedConfigs.additional_ram > 2 ||
  //     selectedConfigs.additional_space > 20;

  //   if (hasCustomConfig) {
  //     // Jika ada config yang di atas base specs, reset ke OS selection dan sembunyikan App Catalog
  //     setSelectedType("os");
  //     setSelectedOsOrApp("choose");
  //     setSelectedVersion("");
  //     setSelectedOsName({ os_name: "", osid: null, osAddon: null });

  //     // Reset VPS PID ke produk utama jika ada config yang dipilih
  //     if (vpsProductsGroup && vpsProductsGroup.length > 0) {
  //       const found = vpsProductsGroup.find(prod => prod.name === currentProdName);
  //       if (found && found.pid !== vpsPid) {
  //         setVpsPid(found.pid);
  //         setVpsProduct({ type: "SET_CURRENT_PID", payload: found.pid });
  //       }
  //     }
  //   }
  // }, [selectedConfigs, vpsProductsGroup, currentProdName, vpsPid]); // Tambahkan vpsPid ke dependency



  // Reset config size saat termin berubah - DISABLED untuk mencegah reset yang tidak diinginkan
  // useEffect(() => {
  //   // Hanya reset jika config saat ini bukan default
  //   const isDefaultConfig = selectedConfigs.additional_cores === 2 && 
  //                          selectedConfigs.additional_ram === 2 && 
  //                          selectedConfigs.additional_space === 20;
    
  //   if (!isDefaultConfig) {
  //     setSelectedConfigs({
  //       additional_cores: 2,
  //       additional_ram: 2,
  //       additional_space: 20
  //     });
  //   }
  // }, [termin, selectedConfigs.additional_cores, selectedConfigs.additional_ram, selectedConfigs.additional_space]);

  // Reset config size saat produk berubah - DISABLED untuk mencegah reset yang tidak diinginkan
  // useEffect(() => {
  //   // Hanya reset jika config saat ini bukan default
  //   const isDefaultConfig = selectedConfigs.additional_cores === 2 && 
  //                          selectedConfigs.additional_ram === 2 && 
  //                          selectedConfigs.additional_space === 20;
    
  //   if (!isDefaultConfig) {
  //     setSelectedConfigs({
  //       additional_cores: 2,
  //       additional_ram: 2,
  //       additional_space: 20
  //     });
  //   }
  // }, [activeProd?.pid, selectedConfigs.additional_cores, selectedConfigs.additional_ram, selectedConfigs.additional_space]);

  // Cleanup debounce timer on unmount
  useEffect(() => {
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, []);

  // Auto-update cart ketika selectedConfigs berubah (jika sudah ada di cart)
  useEffect(() => {
    // Hanya update jika produk sudah ada di cart dan bukan saat pertama kali load
    if (currentProduct.status === "idle" && vpsProduct?.vpsDetails && productsList.length > 0) {
      const existingProduct = productsList.find(product => product.pid === vpsProduct.vpsDetails.pid);
      
      if (existingProduct) {
        // Debounce untuk mencegah update terlalu sering
        if (debounceTimerRef.current) {
          clearTimeout(debounceTimerRef.current);
        }
        
        debounceTimerRef.current = setTimeout(() => {
          // Hitung harga config options menggunakan data langsung dari database
      let configPrice = 0;
      let configoptions = [];

      if (activeProd?.configoptions?.configoption) {
        activeProd.configoptions.configoption.forEach(option => {
              if (option.name === 'additional_cores') {
                // Base specs (2 Core) gratis, hanya tambahan yang berbayar
                if (selectedConfigs.additional_cores > 2) {
                  // Hitung additional cores (total - base)
                  const additionalCores = selectedConfigs.additional_cores - 2;
                  
                  // Cari opsi yang sesuai dengan nilai ADDITIONAL yang dipilih
                  const selectedOption = option.options.option.find(opt => 
                    parseInt(opt.name) === additionalCores
                  );
                  
                  if (selectedOption) {
                    const optionPrice = selectedOption.pricing.IDR[termin];
                    if (optionPrice && optionPrice !== "-1.00") {
                      const totalPrice = parseFloat(optionPrice);
                configPrice += totalPrice;

                configoptions.push({
                  id: option.id,
                        value: selectedOption.id,
                        name: `Additional CPU Cores (+${additionalCores} Core)`,
                  price: totalPrice
                });
                    }
                  }
                }
              }

              if (option.name === 'additional_ram') {
                // Base specs (2GB RAM) gratis, hanya tambahan yang berbayar
                if (selectedConfigs.additional_ram > 2) {
                  // Hitung additional RAM (total - base)
                  const additionalRam = selectedConfigs.additional_ram - 2;
                  
                  // Cari opsi yang sesuai dengan nilai ADDITIONAL yang dipilih (dalam MB)
                  const additionalRamInMB = additionalRam * 1024;
                  const selectedOption = option.options.option.find(opt => 
                    parseInt(opt.name) === additionalRamInMB
                  );
                  
                  if (selectedOption) {
                    const optionPrice = selectedOption.pricing.IDR[termin];
                    if (optionPrice && optionPrice !== "-1.00") {
                      const totalPrice = parseFloat(optionPrice);
                configPrice += totalPrice;

                configoptions.push({
                  id: option.id,
                        value: selectedOption.id,
                        name: `Additional RAM (+${additionalRam} GB)`,
                  price: totalPrice
                });
                    }
                  }
                }
              }

              if (option.name === 'additional_space') {
                // Base specs (20GB Storage) gratis, hanya tambahan yang berbayar
                if (selectedConfigs.additional_space > 20) {
                  // Hitung additional storage (total - base)
                  const additionalSpace = selectedConfigs.additional_space - 20;
                  
                  // Cari opsi yang sesuai dengan nilai ADDITIONAL yang dipilih
                  const selectedOption = option.options.option.find(opt => 
                    parseInt(opt.name) === additionalSpace
                  );
                  
                  if (selectedOption) {
                    const optionPrice = selectedOption.pricing.IDR[termin];
                    if (optionPrice && optionPrice !== "-1.00") {
                      const totalPrice = parseFloat(optionPrice);
                configPrice += totalPrice;

                configoptions.push({
                  id: option.id,
                        value: selectedOption.id,
                        name: `Additional Storage (+${additionalSpace} GB)`,
                  price: totalPrice
                });
                    }
              }
            }
          }
        });
      }

          // Hitung total harga
          // Untuk Managed VPS, ambil harga langsung dari activeProd.pricing.IDR[termin]
          let basePrice = 0;
          if (isManagedVPS && activeProd?.pricing?.IDR?.[termin]) {
            const priceFromAPI = parseFloat(activeProd.pricing.IDR[termin]);
            basePrice = priceFromAPI && priceFromAPI !== -1 ? priceFromAPI : 0;
          } else {
            basePrice = parseFloat(priceByTermin || vpsProduct.vpsDetails.price || 0);
          }
          
          // Hitung OS price
          let osPrice = 0;
          if (selectedOsName.osAddon) {
            const osAddon = selectedOsName.osAddon;
            osPrice = osAddon && osAddon[termin] ? (osAddon[termin] === "-1.00" ? 0 : parseFloat(osAddon[termin]) || 0) : 0;
      }

      const totalPrice = basePrice + osPrice + configPrice;

          // Tentukan nama produk yang benar
          let productName = existingProduct.name; // Default ke nama yang ada
          if (isManagedVPS && prodsValue && prodsValue !== "Nano SC") {
            productName = prodsValue;
          } else if (activeProd?.name) {
            productName = activeProd.name;
          } else if (vpsProduct?.vpsDetails?.name) {
            productName = vpsProduct.vpsDetails.name;
          }

          // Update product data
          const updatedProductData = {
            ...existingProduct,
            name: productName, // Update nama produk
            configoptions: configoptions,
            price: basePrice, // Harga base tetap Rp149.000
            priceWithAddon: totalPrice, // Total harga termasuk addons untuk display
            configPrice: configPrice
          };

          // Update cart
          dispatch(changeProductFromCart(updatedProductData));
          // console.log('🔄 Auto-updated cart with new config:', selectedConfigs);
        }, 500); // Debounce 500ms
      }
    }
  }, [selectedConfigs, currentProduct.status, vpsProduct?.vpsDetails, productsList, activeProd?.configoptions, activeProd?.pricing?.IDR, activeProd?.name, termin, priceByTermin, selectedOsName.osAddon, isManagedVPS, prodsValue, dispatch]);

  // Auto-update cart ketika termin berubah (jika sudah ada di cart)
  useEffect(() => {
    // Hanya update jika produk sudah ada di cart
    if (currentProduct.status === "idle" && vpsProduct?.vpsDetails && productsList.length > 0) {
      const existingProduct = productsList.find(product => product.pid === vpsProduct.vpsDetails.pid);
      
      if (existingProduct) {
        // Debounce untuk mencegah update terlalu sering
        if (debounceTimerRef.current) {
          clearTimeout(debounceTimerRef.current);
        }
        
        debounceTimerRef.current = setTimeout(() => {
          // Hitung OS price berdasarkan termin baru
          let osPrice = 0;
          let vpsaddons = [...(existingProduct.vpsaddons || [])];
          
          if (selectedOsName.osAddon) {
            // OS yang dipilih
            const osAddon = selectedOsName.osAddon;
            osPrice = osAddon && osAddon[termin] ? (osAddon[termin] === "-1.00" ? 0 : parseFloat(osAddon[termin]) || 0) : 0;
            
            // Update vpsaddons - hapus OS lama dan tambahkan OS baru dengan termin yang benar
            vpsaddons = vpsaddons.filter(addon => addon.input_name !== "Operating System");
            // Tambahkan OS addon ke vpsaddons terlepas dari harganya (gratis atau berbayar)
            vpsaddons.push({
              ...osAddon,
              price: osPrice
            });
          } else if (selectedOsName.appInfo) {
            // App Catalog yang dipilih
            const appInfo = selectedOsName.appInfo;
            
            // Cari addon yang sesuai dengan app yang dipilih
            const appAddon = addonsVPS.find(addon => 
              addon.input_name === "Operating System" && 
              addon.name.toLowerCase().includes(appInfo.appLabel.toLowerCase())
            );
            
            if (appAddon) {
              osPrice = appAddon[termin] ? (appAddon[termin] === "-1.00" ? 0 : parseFloat(appAddon[termin]) || 0) : 0;
              
              // Update vpsaddons - hapus OS lama dan tambahkan App baru dengan termin yang benar
              vpsaddons = vpsaddons.filter(addon => addon.input_name !== "Operating System");
              // Tambahkan App addon ke vpsaddons terlepas dari harganya (gratis atau berbayar)
              vpsaddons.push({
                ...appAddon,
                price: osPrice
              });
            }
          }

          // Update customfields untuk OS/App
          let updatedCustomfields = [...(existingProduct.customfields || [])];
          
          // Hapus OS customfield lama
          const osCustomField = activeProd?.customfields?.customfield?.find(
            field => field.name === "Operating System"
          );
          if (osCustomField) {
            updatedCustomfields = updatedCustomfields.filter(field => field.id !== osCustomField.id);
          }
          
          // Tambahkan OS customfield baru
          if (selectedOsName.os_name && osCustomField) {
            updatedCustomfields.push({ id: osCustomField.id, value: selectedOsName.os_name });
          }

          // Hitung ulang configoptions berdasarkan termin baru
          let configPrice = 0;
          let configoptions = [...(existingProduct.configoptions || [])];
          
          if (activeProd?.configoptions?.configoption && selectedConfigs) {
            // Reset configoptions untuk dihitung ulang
            configoptions = [];
            
            activeProd.configoptions.configoption.forEach(option => {
              if (option.name === 'additional_cores') {
                // Base specs (2 Core) gratis, hanya tambahan yang berbayar
                if (selectedConfigs.additional_cores > 2) {
                  // Hitung additional cores (total - base)
                  const additionalCores = selectedConfigs.additional_cores - 2;
                  
                  // Cari opsi yang sesuai dengan nilai ADDITIONAL yang dipilih
                  const selectedOption = option.options.option.find(opt => 
                    parseInt(opt.name) === additionalCores
                  );
                  
                  if (selectedOption) {
                    const optionPrice = selectedOption.pricing.IDR[termin];
                    if (optionPrice && optionPrice !== "-1.00") {
                      const totalPrice = parseFloat(optionPrice);
                      configPrice += totalPrice;

                      configoptions.push({
                        id: option.id,
                        value: selectedOption.id,
                        name: `Additional CPU Cores (+${additionalCores} Core)`,
                        price: totalPrice
                      });
                    }
                  }
                }
              }

              if (option.name === 'additional_ram') {
                // Base specs (2GB RAM) gratis, hanya tambahan yang berbayar
                if (selectedConfigs.additional_ram > 2) {
                  // Hitung additional RAM (total - base)
                  const additionalRam = selectedConfigs.additional_ram - 2;
                  
                  // Cari opsi yang sesuai dengan nilai ADDITIONAL yang dipilih
                  const selectedOption = option.options.option.find(opt => 
                    parseInt(opt.name) === additionalRam * 1024 // Convert GB to MB
                  );
                  
                  if (selectedOption) {
                    const optionPrice = selectedOption.pricing.IDR[termin];
                    if (optionPrice && optionPrice !== "-1.00") {
                      const totalPrice = parseFloat(optionPrice);
                      configPrice += totalPrice;

                      configoptions.push({
                        id: option.id,
                        value: selectedOption.id,
                        name: `Additional RAM (+${additionalRam} GB)`,
                        price: totalPrice
                      });
                    }
                  }
                }
              }

              if (option.name === 'additional_space') {
                // Base specs (20GB Storage) gratis, hanya tambahan yang berbayar
                if (selectedConfigs.additional_space > 20) {
                  // Hitung additional storage (total - base)
                  const additionalSpace = selectedConfigs.additional_space - 20;
                  
                  // Cari opsi yang sesuai dengan nilai ADDITIONAL yang dipilih
                  const selectedOption = option.options.option.find(opt => 
                    parseInt(opt.name) === additionalSpace
                  );
                  
                  if (selectedOption) {
                    const optionPrice = selectedOption.pricing.IDR[termin];
                    if (optionPrice && optionPrice !== "-1.00") {
                      const totalPrice = parseFloat(optionPrice);
                      configPrice += totalPrice;

                      configoptions.push({
                        id: option.id,
                        value: selectedOption.id,
                        name: `Additional Storage (+${additionalSpace} GB)`,
                        price: totalPrice
                      });
                    }
                  }
                }
              }
            });
          }

          // Hitung total harga dengan termin baru
          // Untuk Managed VPS, ambil harga langsung dari activeProd.pricing.IDR[termin]
          let basePrice = 0;
          if (isManagedVPS && activeProd?.pricing?.IDR?.[termin]) {
            const priceFromAPI = parseFloat(activeProd.pricing.IDR[termin]);
            basePrice = priceFromAPI && priceFromAPI !== -1 ? priceFromAPI : 0;
          } else {
            basePrice = parseFloat(priceByTermin || vpsProduct.vpsDetails.price || 0);
          }
          const totalPrice = basePrice + osPrice + configPrice;

          // Tentukan nama produk yang benar
          let productName = existingProduct.name; // Default ke nama yang ada
          if (isManagedVPS && prodsValue && prodsValue !== "Nano SC") {
            productName = prodsValue;
          } else if (activeProd?.name) {
            productName = activeProd.name;
          } else if (vpsProduct?.vpsDetails?.name) {
            productName = vpsProduct.vpsDetails.name;
          }

          // Update product data dengan termin yang benar
          const updatedProductData = {
            ...existingProduct,
            name: productName, // Update nama produk
            vpsaddons: vpsaddons,
            customfields: updatedCustomfields,
            configoptions: configoptions, // Update configoptions dengan harga termin baru
            price: basePrice, // Harga base tetap Rp149.000
            priceWithAddon: totalPrice, // Total harga termasuk addons untuk display
            configPrice: configPrice, // Update configPrice dengan harga termin baru
            osPrice: osPrice,
            billingcycle: termin // Pastikan billing cycle ter-update
          };

          // Update cart
          dispatch(changeProductFromCart(updatedProductData));
          // console.log('🔄 Auto-updated cart with new termin:', termin, 'OS price:', osPrice);
        }, 300); // Debounce 300ms
      }
    }
  }, [termin, currentProduct.status, vpsProduct?.vpsDetails, productsList, priceByTermin, selectedOsName, addonsVPS, activeProd?.customfields, activeProd?.configoptions?.configoption, activeProd?.pricing?.IDR, activeProd?.name, selectedConfigs, isManagedVPS, prodsValue, dispatch]);

  // Auto-update cart ketika produk Managed VPS berubah (jika sudah ada di cart)
  useEffect(() => {
    // Hanya update jika produk sudah ada di cart dan ini adalah Managed VPS
    if (currentProduct.status === "idle" && vpsProduct?.vpsDetails && productsList.length > 0 && isManagedVPS) {
      const existingProduct = productsList.find(product => product.pid === vpsProduct.vpsDetails.pid);
      
      if (existingProduct) {
        // Cek apakah nama produk perlu di-update
        const currentProductName = prodsValue && prodsValue !== "Nano SC" ? prodsValue : (activeProd?.name || existingProduct.name);
        
        if (existingProduct.name !== currentProductName) {
          // Debounce untuk mencegah update terlalu sering
          if (debounceTimerRef.current) {
            clearTimeout(debounceTimerRef.current);
          }
          
          debounceTimerRef.current = setTimeout(() => {
            // Hitung harga base
            let basePrice = 0;
            if (activeProd?.pricing?.IDR?.[termin]) {
              const priceFromAPI = parseFloat(activeProd.pricing.IDR[termin]);
              basePrice = priceFromAPI && priceFromAPI !== -1 ? priceFromAPI : existingProduct.price;
            } else {
              basePrice = existingProduct.price;
            }
            
            // Hitung total harga dengan addons yang ada
            let osPrice = 0;
            if (selectedOsName.osAddon) {
              const osAddon = selectedOsName.osAddon;
              osPrice = osAddon && osAddon[termin] ? (osAddon[termin] === "-1.00" ? 0 : parseFloat(osAddon[termin]) || 0) : 0;
            }
            
            // Hitung config price
            let configPrice = 0;
            if (existingProduct.configoptions && existingProduct.configoptions.length > 0) {
              configPrice = existingProduct.configoptions.reduce((total, config) => total + (parseFloat(config.price) || 0), 0);
            }
            
            const totalPrice = basePrice + osPrice + configPrice;
            
            // Update product data dengan nama produk yang baru
            const updatedProductData = {
              ...existingProduct,
              name: currentProductName, // Update nama produk
              price: basePrice,
              priceWithAddon: totalPrice
            };
            
            // Update cart
            dispatch(changeProductFromCart(updatedProductData));
          }, 300); // Debounce 300ms
        }
      }
    }
  }, [selectedManagedProduct, prodsValue, activeProd?.name, activeProd?.pricing?.IDR, currentProduct.status, vpsProduct?.vpsDetails, productsList, isManagedVPS, termin, selectedOsName.osAddon, dispatch]);

  // const resetProductSelection = (serverId) => {
  //   if (serverId === "725") { // USA server ID
  //     setProdsValue("SC2");
  //   } else {
  //     setProdsValue(vpsProductInit[0].value);
  //   }
  //   setBundleValue({ forLabel: "", forValue: "empty" });
  //   setCurrentPanel(false);
  //   setCurrentSupport(false);
  //   setCurrentSoftaculous(false);
  //   setCurrentOthers(false);
  //   setCurrentBackup(false);
  //   setBundlePromo("choose");
  //   setCurrentBundlingPanel(0);
  //   setCurrentOSBundle(0);
  // };

  const hasAvailableAddons = () => {
    // Cek apakah produk yang ada di cart adalah dari server USA
    const isUSAServer = productsList.some(product =>
      product.gid === 725 || // Server USA GID
      (product.name && product.name.includes("USA"))
    );

    // Jika server USA, return false untuk tidak menampilkan addons
    if (isUSAServer) {
      return false;
    }

    // Jika ada config yang di atas base specs, sembunyikan addons section
    const hasCustomConfig = selectedConfigs.additional_cores > 2 ||
      selectedConfigs.additional_ram > 2 ||
      selectedConfigs.additional_space > 20;
    if (hasCustomConfig) {
      return false;
    }

    // Untuk server lain, tetap cek ketersediaan addons seperti biasa
    return (
      (checkControlPanel.length !== 0 && noBundle) ||
      (checkSoftaculous.length !== 0 && noBundle && isSoftaculous) ||
      checkSupportLevel.length !== 0 ||
      checkAdvancedBackup.length !== 0 ||
      checkOthers.length !== 0
    );
  };

  return (
    <MainLayouts summary={false}>
      {!isManagedVPS && (
      <ServerOptions
        setServer={setServer}
        server={server}
        currentProdName={currentProdName}
        setCurrentName={setCurrentName}
        onServerChange={handleServerChange}
      />
      )}
      <CardWrapper title="Order VPS">
        <div className="align-items-center">
          <div className="row">
            <div className="col-12 col-md-8">
              {currentProdName && currentProdName !== "Loading..." ? (
                <h3 className="text-qw-primary mb-0">{currentProdName}</h3>
              ) : (
                <Placeholder as="h3" animation="glow">
                  <Placeholder bg="danger" xs={6} />
                </Placeholder>
              )}
            </div>
            <div className="col-12 col-md-4 text-md-end text-start mt-1">
              {(() => {
                // Untuk Managed VPS, ambil harga dari activeProd.pricing.IDR[termin]
                let displayPrice = priceByTermin;
                if (isManagedVPS && activeProd?.pricing?.IDR?.[termin]) {
                  const priceFromAPI = parseFloat(activeProd.pricing.IDR[termin]);
                  if (priceFromAPI && priceFromAPI !== -1) {
                    displayPrice = priceFromAPI;
                  }
                }
                
                return displayPrice > 0 ? (
                <>
                  {vpsProduct.promo?.realprice &&
                    vpsProduct.vpsDetails.pid === vpsProduct.promo.pid && (
                      <s className="text-secondary">
                        {formatIDR(vpsProduct.promo.realprice)}
                      </s>
                    )}
                    <h5 className="fw-bold mb-0">{formatIDR(displayPrice)}</h5>
                </>
              ) : (
                <Placeholder as="h5" animation="glow">
                  <Placeholder xs={6} />
                </Placeholder>
                );
              })()}
            </div>
          </div>
          {!isManagedVPS && (
          <div className="col-12 mt-3">
            <button
              className="btn btn-link text-decoration-none p-0 text-qw-primary small"
              onClick={() => setChangeProduct(!changeProduct)}
              style={{ fontSize: "13px" }}
            >
              {changeProduct ? "Sembunyikan" : ""} Pilihan Produk{" "}
              <CollapseIcon
                className="ms-2"
                style={{
                  rotate: changeProduct ? "0deg" : "-90deg",
                  transition: "ease 0.3s",
                }}
              />
            </button>
          </div>
          )}
          {changeProduct && !isManagedVPS && (
            <div className="col-12 py-4 px-3 bg-qw-soft-primary-1 rounded-3 mt-3">
              {/* Radio Button untuk Tipe VPS */}
              <div className="mb-4">
                <label className="fw-bold mb-3">Tipe VPS</label>
                <div className="d-flex gap-4">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="vpsType"
                      id="vpsTypePaket"
                      value="paket"
                      checked={vpsType === "paket"}
                      onChange={changeVpsTypeHandler}
                    />
                    <label className="form-check-label" htmlFor="vpsTypePaket">
                      <strong>Paket</strong>
                      <br />
                      <small className="text-muted">Nano SC, SC1, SC2, SC4, SC8, SC16, SC32, SC64</small>
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="vpsType"
                      id="vpsTypeCustom"
                      value="custom"
                      checked={vpsType === "custom"}
                      onChange={changeVpsTypeHandler}
                    />
                    <label className="form-check-label" htmlFor="vpsTypeCustom">
                      <strong>Custom</strong>
                      <br />
                      <small className="text-muted">Custom VPS (SouthJKT-1, SouthJKT-2, WestJavaBDG-1, USA)</small>
                    </label>
                  </div>
                  
                </div>
              </div>


              {vpsType === "paket" ? (
                <div className="mb-3">
                  <label htmlFor="productVPS" className="fw-bold mb-3">
                    Pilih Produk
                  </label>
                  <select
                    name="productVPS"
                    id="productVPS"
                    className="form-select"
                    onChange={changeVpsProductHandler}
                    value={prodsValue || ""}
                  >
                    <option value="">Pilih Produk</option>
                    {getVpsProductOptions()
                      .filter(prods => prods.value !== "Custom" && !prods.value.includes("Custom"))
                      .map((prods, index) => (
                        <option value={prods.value} key={`${prods.id}-${index}`}>
                        {prods.value}
                      </option>
                    ))}
                  </select>
                  
                </div>
              ) : (
                <div className="mb-3">
                  <label className="fw-bold mb-3">
                    Produk VPS
                  </label>
                  <div className="p-3 bg-light rounded border">
                    <h6 className="mb-0 text-primary">
                      <i className="fas fa-server"></i>
                      Custom VPS
                    </h6>
                    <small className="text-muted">
                      VPS dengan konfigurasi yang dapat disesuaikan sesuai kebutuhan
                    </small>
                  </div>
                </div>
              )}

              {/* Billing Cycle Options - dipindahkan ke sini */}
              <div className="mb-3">
                <BillingCycleOptions
                  termin={termin}
                  terminHandle={changeTerminHandler}
                  productsItem={vpsProduct}
                  managedVpsPricing={isManagedVPS ? activeProd?.pricing?.IDR : null}
                />
              </div>
            </div>
          )}

          {/* Section 2: Spesifikasi VPS + Konfigurasi Tambahan berdasarkan Tipe VPS */}
          {changeProduct && !isManagedVPS && (
            <>
              {vpsType === "paket" ? (
                /* VPS Paket: Hanya tampilkan Spesifikasi VPS dengan col-12 */
                <div className="col-12 py-4 px-3 bg-light rounded-3 mt-3">
                  <VpsSpecsDisplay
                    productName={prodsValue}
                    configs={selectedConfigs}
                    showConfigSelector={false}
                    onConfigChange={handleConfigChange}
                    configOptions={activeProd?.configoptions?.configoption}
                    termin={termin}
                  />
                </div>
              ) : (
                /* VPS Custom: Tampilkan Spesifikasi VPS + Konfigurasi Tambahan dalam 2 kolom */
                <div className="row mt-3">
                  {/* Kolom 1: Spesifikasi VPS dengan Background Abu - Sembunyikan di mobile */}
                  <div className="col-md-6 d-none d-md-block">
                    <div className="py-4 px-3 bg-light rounded-3 h-100">
                      <VpsSpecsDisplay
                        productName="Custom VPS"
                        configs={selectedConfigs}
                        showConfigSelector={false}
                        onConfigChange={handleConfigChange}
                        configOptions={activeProd?.configoptions?.configoption}
                        termin={termin}
                      />
                    </div>
                  </div>

                  {/* Kolom 2: Konfigurasi Tambahan dengan Background Orange - Full width di mobile */}
                  <div className="col-12 col-md-6">
                    <div className="py-4 px-3 bg-qw-soft-primary-1 rounded-3 h-100">
                      {(() => {
                        // Gunakan kondisi yang lebih sederhana untuk sementara
                        const hasBasicConfigOptions = activeProd?.configoptions?.configoption && 
                          activeProd.configoptions.configoption.length > 0;
                        
                        return hasBasicConfigOptions;
                      })() ? (
                        <ConfigSizeSelector
                          key={`${activeProd.pid}-${termin}`}
                          configOptions={activeProd.configoptions.configoption}
                          selectedConfigs={selectedConfigs}
                          onConfigChange={handleConfigChange}
                          termin={termin}
                          disabled={false}
                        />
                      ) : (
                        <div className="text-center p-3 bg-light rounded h-100 d-flex align-items-center justify-content-center">
                          <div>
                            <div className="spinner-border spinner-border-sm text-primary mb-2" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                            <div>
                          <small className="text-muted">
                                Memuat konfigurasi tambahan...
                          </small>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Info tambahan jika config berubah */}
                      {(selectedConfigs.additional_cores > 2 || selectedConfigs.additional_ram > 2 || selectedConfigs.additional_space > 20) && (
                        <div className="mt-3 p-3 bg-warning bg-opacity-10 border border-warning rounded">
                          <small className="text-warning">
                            <strong>Info:</strong> App Catalog tidak tersedia saat menggunakan konfigurasi tambahan.
                          </small>
                          <div className="mt-2">
                            <button
                              className="btn btn-sm btn-outline-warning"
                              onClick={() => setSelectedConfigs({
                                additional_cores: 2,
                                additional_ram: 2,
                                additional_space: 20
                              })}
                            >
                              Reset ke Default
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </>
          )}


          {/* Section 4: Virtual Machine & App Catalog */}
          {changeProduct && (
            <div className="col-12 py-4 px-3 bg-light rounded-3 mt-3">
              {/* Cek apakah addonsVPS tersedia untuk Custom VPS */}
              {(() => {
                const hasOsAddons = addonsVPS && addonsVPS.length > 0 && addonsVPS.some(addon => addon.input_name === "Operating System");
                // console.log('🔍 Debug OS Addons:', {
                //   vpsType,
                //   addonsVPSLength: addonsVPS?.length || 0,
                //   hasOsAddons,
                //   addonsVPS: addonsVPS
                // });
                return vpsType === "custom" && !hasOsAddons;
              })() ? (
                <div className="text-center py-4">
                  <div className="alert alert-warning" role="alert">
                    <h5 className="alert-heading">⚠️ Operating System Tidak Tersedia</h5>
                    <p className="mb-0">
                      Maaf OS Produk ini tidak tersedia, Silahkan hubungi Support kami!
                    </p>
                    {/* <hr />
                    <p className="mb-0">
                      <small>
                        Jika Anda memerlukan bantuan, silakan hubungi tim support kami melalui:
                        <br />
                        📧 Email: support@qwords.com
                        <br />
                        📞 Telepon: 021-39708800
                      </small>
                    </p> */}
                  </div>
                </div>
              ) : (
                <>
                  {/* 1. Produk Selector untuk Managed VPS */}
                  {isManagedVPS && managedVpsProducts.length > 0 && (
                    <div className="mb-4">
                      <Form.Label className="fw-bold mb-2">
                        Pilih Produk <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Select
                        value={selectedManagedProduct || ""}
                        onChange={(e) => {
                          const selectedPid = parseInt(e.target.value);
                          const selectedProduct = managedVpsProducts.find(p => p.pid === selectedPid);
                          
                          setSelectedManagedProduct(selectedPid);
                          setVpsPid(selectedPid);
                          setVpsProduct({ type: "SET_CURRENT_PID", payload: selectedPid });
                          
                          // Update product name untuk ditampilkan
                          if (selectedProduct) {
                            setProdsValue(selectedProduct.name);
                            setBaseProdName(selectedProduct.name);
                            setCurrentName(selectedProduct.name);
                          }
                          
                          dispatch(getProduct(selectedPid));
                          dispatch(getAddonsVPS(selectedPid));
                          
                          // Reset OS, panel, dan immunify saat produk berubah
                          setSelectedOsName({ os_name: "", osid: null, osAddon: null });
                          setCurrentPanel(false);
                          setSelectedManagedPanel(null); // Reset panel, akan auto-select default (ID 157) setelah addons dimuat
                          setSelectedManagedImmunify(null); // Reset immunify, akan auto-select default (ID 117) setelah addons dimuat
                        }}
                      >
                        <option value="">Pilih Produk</option>
                        {managedVpsProducts.map((product) => (
                          <option key={product.pid} value={product.pid}>
                            {product.name}
                          </option>
                        ))}
                      </Form.Select>
                    </div>
                  )}

                  {/* 2. Pilih Termin untuk Managed VPS */}
                  {isManagedVPS && (
                    <div className="mb-4">
                      <BillingCycleOptions
                        termin={termin}
                        terminHandle={changeTerminHandler}
                        productsItem={vpsProduct}
                        managedVpsPricing={activeProd?.pricing?.IDR}
                      />
                    </div>
                  )}

                  {/* 3. OS Selector untuk Managed VPS */}
              <VpsOsAppSelector
                selectedType={selectedType}
                setSelectedType={setSelectedType}
                selectedOsOrApp={selectedOsOrApp}
                setSelectedOsOrApp={setSelectedOsOrApp}
                onOsNameChange={handleOsNameChange}
                baseProdName={baseProdName}
                productListCache={productListCache}
                addonsVPS={addonsVPS}
                showAppCatalog={vpsType === "paket" || (vpsType === "custom" && selectedConfigs.additional_cores === 2 && selectedConfigs.additional_ram === 2 && selectedConfigs.additional_space === 20)}
                configs={selectedConfigs}
                    isManagedVPS={isManagedVPS}
                  />
                  
                  {/* 4. Panel Selector untuk Managed VPS */}
                  {isManagedVPS && addonsVPS && addonsVPS.length > 0 && (() => {
                    // Filter semua panel dari addonsVPS
                    const panelAddons = addonsVPS.filter(addon => 
                      addon.input_name === "Control Panel"
                    );
                    
                    return panelAddons.length > 0 ? (
                      <div className="mb-4">
                        <Form.Label className="fw-bold mb-2">
                          Pilih Panel <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          value={selectedManagedPanel || ""}
                          onChange={(e) => {
                            const selectedPanelId = parseInt(e.target.value);
                            setSelectedManagedPanel(selectedPanelId);
                            
                            // Cari dan set panel addon berdasarkan ID
                            const panelAddon = addonsVPS.find(addon => 
                              addon.id === selectedPanelId && 
                              addon.input_name === "Control Panel"
                            );
                            
                            if (panelAddon) {
                              setCurrentPanel(panelAddon);
                              const targetPid = activeProd?.pid || selectedManagedProduct;
                              // Hanya dispatch addVpsAddons jika produk sudah ada di cart
                              if (targetPid) {
                                const existingProduct = productsList.find(product => product.pid === targetPid);
                                if (existingProduct) {
                                  dispatch(addVpsAddons({ pid: targetPid, addons: panelAddon }));
                                }
                              }
                            }
                          }}
                        >
                          <option value="">Pilih Panel</option>
                          {panelAddons.map((panel) => (
                            <option key={panel.id} value={panel.id}>
                              {panel.name}
                            </option>
                          ))}
                        </Form.Select>
                      </div>
                    ) : null;
                  })()}
                  
                  {/* 5. Immunify Selector untuk Managed VPS */}
                  {isManagedVPS && addonsVPS && addonsVPS.length > 0 && (() => {
                    // Filter semua Immunify dari addonsVPS
                    const immunifyAddons = addonsVPS.filter(addon => 
                      addon.input_name === "Immunify"
                    );
                    
                    return immunifyAddons.length > 0 ? (
                      <div className="mb-4">
                        <Form.Label className="fw-bold mb-2">
                          Pilih Immunify <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          value={selectedManagedImmunify || ""}
                          onChange={(e) => {
                            const selectedImmunifyId = parseInt(e.target.value);
                            setSelectedManagedImmunify(selectedImmunifyId);
                            
                            // Cari dan set immunify addon berdasarkan ID
                            const immunifyAddon = addonsVPS.find(addon => 
                              addon.id === selectedImmunifyId && 
                              addon.input_name === "Immunify"
                            );
                            
                            if (immunifyAddon) {
                              const targetPid = activeProd?.pid || selectedManagedProduct;
                              // Hanya dispatch addVpsAddons jika produk sudah ada di cart
                              if (targetPid) {
                                const existingProduct = productsList.find(product => product.pid === targetPid);
                                if (existingProduct) {
                                  dispatch(addVpsAddons({ pid: targetPid, addons: immunifyAddon }));
                                }
                              }
                            }
                          }}
                        >
                          <option value="">Pilih Immunify</option>
                          {immunifyAddons.map((immunify) => (
                            <option key={immunify.id} value={immunify.id}>
                              {immunify.name}
                            </option>
                          ))}
                        </Form.Select>
                      </div>
                    ) : null;
                  })()}
                </>
              )}
            </div>
          )}

          <div className="row g-3 mt-3">
            <div className="col-12 col-md-6">
              <label htmlFor="hostname" className="fw-bold mb-2 d-block">
                Hostname <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${hostnameError ? 'is-invalid' : ''}`}
                id="hostname"
                name="hostname"
                ref={hostnameRef}
                onChange={handleHostnameChange}
                placeholder="contoh: server01.domain.com"
                style={{ fontSize: 'clamp(0.875rem, 1.2vw, 1rem)' }}
              />
              {hostnameError && (
                <div className="invalid-feedback d-block">
                  {hostnameError}
                </div>
              )}
              <div className="form-text mt-2">
                <small className="text-muted" style={{ fontSize: 'clamp(0.75rem, 1vw, 0.875rem)' }}>
                  <i className="fas fa-info-circle"></i>
                  Hostname hanya boleh mengandung huruf (a-z, A-Z), angka (0-9), dan tanda hubung (-). 
                  Maksimal 63 karakter per bagian dan 255 karakter total.
                </small>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <label htmlFor="password" className="fw-bold mb-2 d-block">
                Password <span className="text-danger">*</span>
              </label>
              <div className="position-relative">
                <input
                  type="password"
                  className="form-control"
                  style={{ 
                    paddingRight: "45px",
                    fontSize: 'clamp(0.875rem, 1.2vw, 1rem)'
                  }}
                  id="password"
                  name="password"
                  ref={passwordRef}
                  onChange={changePasswordHandler}
                  placeholder="Min 8 karakter, kombinasi huruf, angka & simbol"
                />
                <button
                  className="btn btn-link position-absolute border-0 bg-transparent p-0"
                  style={{ 
                    right: "8px", 
                    top: "50%", 
                    transform: "translateY(-50%)",
                    width: "32px",
                    height: "32px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 10
                  }}
                  type="button"
                  onClick={toggleVisibilityHandler}
                  aria-label="Toggle password visibility"
                >
                  <img 
                    ref={peekIconRef} 
                    src={Peek} 
                    alt="Toggle visibility" 
                    style={{ width: "20px", height: "20px" }}
                  />
                </button>
              </div>
              {passwordStrength.score !== 0 && (
                <div className="mt-2">
                  <ProgressBar
                    variant={passwordStrength.variant}
                    now={passwordStrength.score}
                    style={{ height: "6px" }}
                  />
                  <div
                    className={`text-${passwordStrength.variant} fw-bold mt-1`}
                    style={{ fontSize: 'clamp(0.75rem, 1vw, 0.875rem)' }}
                  >
                    {passwordStrength.title}
                  </div>
                </div>
              )}
              <div className="form-text mt-2">
                <small className="text-muted" style={{ fontSize: 'clamp(0.75rem, 1vw, 0.875rem)' }}>
                  <i className="fas fa-info-circle"></i>
                  Password minimal 8 karakter dengan kombinasi huruf, angka, dan simbol
                </small>
            </div>
          </div>
          </div>
          {noBundle && !isManagedVPS ? (
            <>
              {/* <div className="col-12 mt-3">
                <AddonsVPSDropdown
                  label="Operating System"
                  optionData={addonsVPS}
                  setSelectOS={setVpsProduct}
                  setCurrentOS={setCurrentOS}
                  currentOSBundle={currentOSBundle}
                  setCurrentOSBundle={setCurrentOSBundle}
                  setBundlePromo={setBundlePromo}
                  bundlePromo={bundlePromo}
                />
              </div> */}
              {showPromoBundling ? (
                <div className="mt-4 mb-4">
                  <div className="row g-3">
                    <div className="col-12 col-md-7 col-lg-8 d-flex flex-column">
                      <Form.Label className="fw-bold mb-2 d-block">
                        Promo Bundle
                      </Form.Label>
                      <div className="d-flex flex-column">
                      <Form.Select
                        onChange={changeBundlePromoHandler}
                          disabled={productsList.length === 0}
                        value={bundlePromo}
                          style={{ fontSize: 'clamp(0.875rem, 1.2vw, 1rem)' }}
                          className={productsList.length === 0 ? 'opacity-75' : ''}
                      >
                        <option value="choose" id="0" price="0">
                            {productsList.length === 0 ? 'Tambahkan produk ke cart terlebih dahulu' : 'Pilih...'}
                        </option>
                        {bundlePromos.map((opt, index) => {
                          const isSC1 = currentProdName.includes("SC1");
                          const isSC2 = currentProdName.includes("SC2");
                          const isLastOption =
                            index === bundlePromos.length - 1;

                          if (isSC1 && isLastOption) {
                            return null;
                          }
                          if (isSC2 && isLastOption) {
                            return null;
                          }

                          return (
                            <option
                              value={opt.value}
                              key={opt.id}
                              id={opt.label}
                                disabled={productsList.length === 0}
                            >
                              {opt.label}
                            </option>
                          );
                        })}
                      </Form.Select>
                        {/* {productsList.length === 0 && (
                          <small className="text-muted d-block mt-1" style={{ fontSize: 'clamp(0.75rem, 1vw, 0.875rem)' }}>
                            <i className="fas fa-info-circle me-1"></i>
                            Tambahkan produk VPS ke keranjang terlebih dahulu
                          </small>
                        )} */}
                    </div>
                    </div>
                    <div className="col-12 col-md-5 col-lg-4 d-flex flex-column justify-content-end">
                      <div className="d-flex flex-column align-items-start align-items-md-end">
                      {bundlePromo === "choose" ? (
                          <span className="badge btn-cta badge-promo-bundle w-100 w-md-auto text-center">
                            <i className="fas fa-tag me-2"></i>
                          DISKON UP TO 50%
                        </span>
                      ) : (
                          <div className="d-flex flex-column align-items-end w-100 w-md-auto">
                            <p className="fw-bold mb-1 text-secondary promo-price-old">
                            <del>
                              Rp
                              {(hargaBundle
                                ? parseInt(hargaBundle) + delBundlePrice
                                : delBundlePrice
                              ).toLocaleString("id-ID")}
                            </del>
                          </p>
                            <span className="badge btn-cta badge-promo-bundle text-center">
                              <i className="fas fa-check-circle me-2"></i>
                            Rp
                            {(hargaBundle
                              ? parseInt(hargaBundle) + bundlePrice
                              : bundlePrice
                            ).toLocaleString("id-ID")}
                          </span>
                          </div>
                      )}
                    </div>
                  </div>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </>
          ) : (
            <></>
          )}
          {showPromo && vpsProduct && (
            <PromoKaosTumbler
              price={total}
              billingcycle={termin}
            />
          )}
          {/* {showPromoSsl && (
            <>
              <div className="col-12 col-md-6 col-lg-8 align-self-center mt-4">
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    name="ssl_premium"
                    id="ssl_premium"
                    value="ssl_premium"
                    onChange={changePromoJuniSslHandler}
                    checked={promoJuniSsl}
                  />
                  <label
                    htmlFor="ssl_premium"
                    className="ms-3 form-check-label fw-bold"
                    style={{ fontSize: "16px" }}
                  >
                    SSL Premium Certum
                  </label>
                  <span
                    className="badge bg-primary text-white ms-2"
                    style={{
                      borderRadius: "20px",
                      fontSize: "14px",
                    }}
                  >
                    {freeSsl ? "Diskon 100%" : "Diskon 40%"}
                  </span>
                </div>
              </div>
              <div className="col-12 col-lg-4 d-grid justify-content-end align-self-center mt-4">
                <p className="fw-bold mb-0 d-inline-block text-secondary">
                  <del>Rp100.000</del>
                </p>
                <span className="badge btn-cta p-2">
                  {freeSsl ? "Gratis" : "Rp60.000"}
                </span>
              </div>
            </>
          )} */}
          <AddToCartButton
            onClick={addToCartHandler}
            disabled={isButtonDisabled}
          />
        </div>
      </CardWrapper>
      <div ref={addonsRef}>
        {productsList &&
          productsList.length !== 0 &&
          hasAvailableAddons() && (
            <CardWrapper title="Addons VPS (Opsional)">
              {/* Config options lama sudah diganti dengan ConfigSizeSelector */}

              {checkControlPanel.length !== 0 && noBundle && (
                <AddonsVPSDropdown
                  label="Control Panel"
                  optionData={addonsVPS}
                  setCurrentPanel={setCurrentPanel}
                  currentBundlingPanel={currentBundlingPanel}
                  setBundlePromo={setBundlePromo}
                  bundlePromo={bundlePromo}
                />
              )}
              {checkSoftaculous.length !== 0 && noBundle && isSoftaculous && (
                <AddonsVPSDropdown
                  label="Softaculous"
                  optionData={addonsVPS}
                  setCurrentSoftaculous={setCurrentSoftaculous}
                />
              )}
              {checkSupportLevel.length !== 0 && (
                <AddonsVPSDropdown
                  label="Support Level"
                  optionData={addonsVPS}
                  setCurrentSupport={setCurrentSupport}
                />
              )}
              {checkAdvancedBackup.length !== 0 && (
                <AddonsVPSDropdown
                  label="Advanced Backup"
                  optionData={addonsVPS}
                  setCurrentBackup={setCurrentBackup}
                />
              )}
              {checkOthers.length !== 0 && (
                <AddonsVPSDropdown
                  label="Others"
                  optionData={addonsVPS}
                  setCurrentOthers={setCurrentOthers}
                />
              )}
            </CardWrapper>
          )}
      </div>
    </MainLayouts>
  );
};

const CollapseIcon = (props) => {
  return (
    <img
      {...props}
      src={collapseIcon}
      alt="icon.png"
      height={"auto"}
      width={12}
    />
  );
};

export default Vps;
